{
  "nav": {
    "dashboard": "Dashboard",
    "chats": "Chat",
    "archive": "Archivio",
    "settings": "Impostazioni",
    "studioData": "Dati Studio",
    "propertyData": "Dati di proprietà",
    "expandMenu": "Espandi menu",
    "collapseMenu": "Comprimi menu",
    "goToDashboard": "Vai al pannello di controllo",
    "logOut": "Esci"
  },
  "layout": {
    "lastUpdatedJustNow": "Appena aggiornato",
    "lastUpdatedOneMin": "Ultimo aggiornamento: 1 minuto fa",
    "lastUpdatedMins": "Ultimo aggiornamento: {{count}} min fa",
    "wsOffline": "Connessione persa. Aggiorna o attendi la riconnessione.",
    "refresh": "Aggiorna",
    "refreshing": "Ripristinare"
  },
  "settings": {
    "title": "Impostazioni",
    "subtitle": "Gestisci account, team e canali.",
    "tabAccount": "Account",
    "tabTeam": "Team Management",
    "tabChannels": "Scanalature",
    "tabAi": "Comportamento AI",
    "logOut": "Esci",
    "noPermissionToast": "Non hai il permesso di visualizzare questa attività.",
    "connections": {
      "email": {
        "channelLabel": "E-mail",
        "appliesToAllStudios": "Tutti gli studi",
        "addressLabel": "Casella di posta",
        "defaultStudioLabel": "Studio predefinito per nuovi thread",
        "statusConnected": "Connesso",
        "statusReconnectRequired": "Riconnessione richiesta",
        "statusDisconnected": "Non connesso",
        "statusError": "Errore",
        "statusSkipped": "Saltato",
        "connect": "Connetti",
        "reconnect": "Riconnetti",
        "disconnect": "Disconnetti",
        "reconnectBanner": "La connessione e-mail è scaduta. Riconnetti per inviare e ricevere messaggi.",
        "reconnectBannerCta": "Riconnetti e-mail",
        "disconnectTitle": "Disconnettere l’e-mail?",
        "disconnectBody": "Questo revoca l’accesso alla casella condivisa. I thread passati restano leggibili; l’invio è disabilitato fino a una nuova connessione.",
        "toastDisconnected": "E-mail disconnessa.",
        "toastDisconnectFailed": "Impossibile disconnettere l’e-mail."
      }
    }
  },
  "account": {
    "displayLanguageTitle": "Display language",
    "displayLanguageHint": "Inglese, tedesco, francese, italiano e spagnolo si applicano all'intera app, inclusi accesso, registrazione e onboarding.",
    "displayLanguageLabel": "Lingua",
    "languageUpdated": "Lingua di visualizzazione aggiornata.",
    "emailTitle": "Indirizzo Email",
    "newEmail": "Nuova e-mail",
    "currentPassword": "Password attuale",
    "emailPasswordPlaceholder": "Necessario per modificare l'e-mail",
    "save": "Salva",
    "cancel": "Annulla",
    "changeEmail": "Cambia e-mail",
    "passwordTitle": "Password",
    "passwordSharedWarning": "Questa password è condivisa tra l'app studio OktoGo e il portale Management. Modificandola qui aggiorni l'accesso a entrambi.",
    "passwordConfirmTitle": "Modificare la password su entrambe le piattaforme?",
    "passwordConfirmBody": "Questo modifica l’accesso sia all’app studio OktoGo (app.oktogo.ai) sia a Management, usando lo stesso indirizzo e-mail.",
    "passwordConfirmCancel": "Annulla",
    "passwordConfirmSubmit": "Sì, modifica la password",
    "newPassword": "Nuova password",
    "confirmNewPassword": "Conferma la nuova password",
    "updatePassword": "Aggiorna password",
    "changePassword": "Modifica Password",
    "verticalLabel": "Verticale",
    "notificationTitle": "Preferenze di notifica",
    "escalationAlerts": "Avvisi di escalation",
    "escalationAlertsDesc": "Push quando una chat viene escalationata per revisione o presa in carico umana (sempre attivo). L'email di escalation con motivo ed estratto chat è distinta dalle email di scadenza sessione WhatsApp. Un'opzione Account per silenziare solo l'email di escalation arriverà presto; il push resta attivo.",
    "weeklySummary": "Riepilogo settimanale",
    "weeklySummaryDesc": "Ricevi un rapporto settimanale sulle prestazioni",
    "connectionWarnings": "Avvertenze di connessione",
    "connectionWarningsDesc": "Avvisa quando viene persa una connessione alla piattaforma",
    "notificationsSaved": "Preferenze di notifica dell'utente salvate!",
    "verticalFitness": "Palestra",
    "verticalStr": "Affitto a breve termine",
    "toastCurrentPasswordForEmail": "Inserisci la tua password attuale per modificare l'e-mail.",
    "toastVerificationEmailSent": "Email di verifica inviata al nuovo indirizzo.",
    "toastEmailUpdateFailed": "Impossibile aggiornare l'e-mail.",
    "toastPasswordMismatch": "Le password non sono uguali",
    "toastPasswordUpdated": "Aggiornamento password riuscito",
    "toastPasswordUpdateFailed": "Impossibile aggiornare la password.",
    "toastVerticalUpdated": "Prodotto verticale aggiornato.",
    "toastVerticalUpdateFailed": "Impossibile aggiornare verticalmente.",
    "toastPreferencesSaveFailed": "Salvataggio non riuscito ",
    "studioNameTitleStudio": "Nome studio",
    "studioNameTitleProperty": "Nome proprietà",
    "studioNameHint": "È così che la tua struttura compare nell’app, nelle notifiche e nei messaggi rivolti ai clienti.",
    "studioNameContextHint": "Seleziona un singolo studio per modificarne il nome.",
    "studioNameValidation": "Il nome deve avere tra 2 e 60 caratteri.",
    "toastStudioNameUpdated": "Nome studio aggiornato.",
    "toastPropertyNameUpdated": "Nome proprietà aggiornato.",
    "toastStudioNameUpdateFailed": "Impossibile aggiornare il nome."
  },
  "auth": {
    "languageSwitcherAria": "Lingua di visualizzazione",
    "placeholderEmailExample": "tu@studio.com",
    "placeholderPassword": "••••••••",
    "placeholderPasswordCreate": "Imposta la password",
    "placeholderPasswordConfirm": "Ripeti la password",
    "placeholderStudioName": "Nome del tuo studio",
    "onboardingSelectPlatform": "Seleziona la piattaforma",
    "onboarding2faSecret": "Inserisci il segreto 2FA o il codice di backup",
    "login": {
      "subtitle": "Accedi al tuo studio",
      "lockout": "Troppi tentativi falliti. Riprova tra {{minutes}} minuti.",
      "emailLabel": "Indirizzo email",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Inserisci la password",
      "rememberMe": "Ricordami",
      "rememberMeHelpOn": "Resta connesso su questo dispositivo anche dopo aver chiuso il browser.",
      "rememberMeHelpOff": "Verrai disconnesso alla chiusura del browser.",
      "logIn": "Accedi",
      "forgotPassword": "Password dimenticata?",
      "orDivider": "oppure",
      "continueWithGoogle": "Continua con Google",
      "noAccount": "Non hai un account?",
      "createAccount": "Crea un account →",
      "sessionExpiredToast": "La sessione è scaduta. Accedi di nuovo.",
      "pilotInviteHandoff": "Il tuo invito pilota è stato accettato. Accedi con la password che hai appena creato.",
      "errorIncorrectCredentials": "Email o password non corretti.",
      "errorEmailNotVerified": "L'indirizzo email non è verificato.",
      "resendVerificationAction": "Reinvia email di verifica",
      "resendVerificationToast": "Email di verifica inviata. Controlla la posta in arrivo.",
      "resendVerificationRateLimited": "Troppi tentativi. Attendi 15 minuti prima di richiedere un'altra email.",
      "goToVerificationPage": "Vai alla pagina di verifica →",
      "errorNetwork": "Impossibile raggiungere il server. Avvia l'API (es. npm run dev o dev:server) e riprova.",
      "errorGooglePopupBlocked": "Un popup è stato bloccato dal browser. Consenti i popup per questo sito e riprova.",
      "errorGoogleSignIn": "Accesso con Google non riuscito. Riprova o usa email e password."
    },
    "register": {
      "subtitle": "Crea il tuo account",
      "studioNameLabel": "Nome studio",
      "emailLabel": "Indirizzo email",
      "passwordLabel": "Password",
      "createAccount": "Crea account",
      "orDivider": "oppure",
      "continueWithGoogle": "Continua con Google",
      "hasAccount": "Hai già un account?",
      "logIn": "Accedi →",
      "validationStudioName": "Il nome del studio deve avere almeno 2 caratteri.",
      "validationEmail": "Inserisci un indirizzo email valido.",
      "validationPassword": "La password deve avere almeno 8 caratteri, 1 lettera e 1 numero.",
      "registrationFailed": "Registrazione non riuscita. Riprova.",
      "duplicateEmailLead": "Esiste già un account con questa email.",
      "duplicateEmailLink": "Accedi →"
    },
    "forgot": {
      "subtitle": "Reimposta la password",
      "emailLabel": "Indirizzo email",
      "sentLead": "Controlla la posta in arrivo. Abbiamo inviato un link per reimpostare la password.",
      "backToLogin": "← Torna al login",
      "testResetLink": "(Test: vai alla pagina reimposta password)",
      "sendResetLink": "Invia link di reimpostazione",
      "errorGeneric": "Qualcosa è andato storto. Riprova.",
      "networkError": "Errore di rete. Riprova."
    },
    "reset": {
      "invalidLink": "Questo link di reimpostazione non è valido o è scaduto.",
      "requestNewLink": "Richiedi un nuovo link →",
      "tokenUsed": "Questo link è già stato utilizzato.",
      "requestNewOne": "Richiedi un nuovo link →",
      "successBody": "Password aggiornata. Accedi.",
      "goToLogin": "Vai al login →",
      "subtitle": "Imposta una nuova password",
      "newPasswordLabel": "Nuova password",
      "confirmPasswordLabel": "Conferma password",
      "resetButton": "Reimposta password",
      "testSimulateUsed": "(Test: simula token già usato)",
      "errorPasswordRules": "La password deve avere almeno 8 caratteri, 1 lettera e 1 numero.",
      "errorPasswordMismatch": "Le password non coincidono.",
      "errorTokenExpired": "Questo link è scaduto. Richiedine uno nuovo.",
      "networkError": "Errore di rete. Riprova.",
      "errorGeneric": "Qualcosa è andato storto."
    },
    "invite": {
      "invalidToken": "Questo link di invito non è valido.",
      "goToLogin": "Vai al login →",
      "subtitle": "Accetta l'invito del team",
      "invalidUsed": "Questo invito non è valido o è già stato usato.",
      "expired": "Questo invito è scaduto.",
      "expiredHint": "Chiedi all'amministratore del studio di reinviare l'invito.",
      "successRedirect": "Invito accettato. Reindirizzamento alla dashboard…",
      "createPasswordLabel": "Crea password",
      "termsPrivacy": "Accetto i Termini di servizio e l'Informativa sulla privacy.",
      "acceptButton": "Accetta invito",
      "validationPassword": "La password deve avere almeno 8 caratteri, 1 lettera e 1 numero.",
      "validationTerms": "Devi accettare termini e privacy per continuare.",
      "errorAcceptFailed": "Impossibile accettare l'invito.",
      "errorNoSession": "Invito accettato ma sessione di accesso non creata.",
      "networkError": "Errore di rete. Riprova."
    },
    "civ": {
      "documentTitle": "Conferma la tua e-mail — OktoGo",
      "headerSubtitle": "Confermando l'e-mail, lo studio può proseguire la tua prenotazione.",
      "consent": {
        "headline": "Conferma la tua identità per {{ studioName }}",
        "body": "In questo modo confermi questo indirizzo e-mail e autorizzi {{ studioName }} (con tecnologia OktoGo.ai) a completare la prenotazione richiesta su {{ channelLabel }}.",
        "checkboxEmail": "Confermo che questo indirizzo e-mail è mio.",
        "checkboxData": "Acconsento al trattamento e all'archiviazione dei miei dati personali da parte di OktoGo.ai per gestire questa richiesta, come descritto nell'<a>informativa sulla privacy</a>.",
        "privacyPolicyAriaLabel": "Informativa sulla privacy di OktoGo.ai (si apre in una nuova scheda)",
        "confirmButton": "Conferma e continua",
        "confirmButtonSubmitting": "Conferma in corso…",
        "declineLink": "Non sono stato io — rifiuta",
        "errorGeneric": "Qualcosa è andato storto. Riprova o contatta l'assistenza.",
        "errorRateLimited": "Troppi tentativi. Attendi un momento e riprova.",
        "errorVersionMismatch": "Abbiamo aggiornato questa pagina. Aggiornala e riprova."
      },
      "success": {
        "headline": "Sei verificato.",
        "body": "Ora puoi tornare alla chat {{ channelLabel }} con {{ studioName }} per continuare. Riprendiamo esattamente da dove avevi lasciato.",
        "closeHint": "Puoi chiudere questa scheda in sicurezza."
      },
      "error": {
        "expiredHeadline": "Questo link è scaduto",
        "expiredBody": "Per la tua sicurezza, il link è valido solo per un breve periodo. Rispondi nella tua chat e te ne invieremo uno nuovo.",
        "invalidHeadline": "Questo link non è valido",
        "invalidBody": "Impossibile riconoscere il link. Rispondi nella tua chat per ricominciare.",
        "usedHeadline": "Già confermato",
        "usedBody": "Questo indirizzo e-mail è già stato confermato. Puoi tornare alla tua chat per continuare.",
        "networkHeadline": "Problema di connessione",
        "networkBody": "Impossibile contattare OktoGo. Controlla la tua connessione Internet e riprova.",
        "networkRetryButton": "Riprova"
      },
      "declined": {
        "headline": "Capito — non continueremo.",
        "body": "Abbiamo registrato il tuo rifiuto. Se si è trattato di un errore, contatta l'assistenza e ti aiuteremo."
      },
      "terminal": {
        "contactSupport": "Contatta l'assistenza",
        "contactSupportAriaLabel": "Invia un'e-mail all'assistenza OktoGo"
      }
    },
    "verify": {
      "title": "Controlla la posta in arrivo",
      "bodyGeneric": "Abbiamo inviato un link di verifica al tuo indirizzo email. Clicca il link per verificare l'account.",
      "bodyWithEmail": "Abbiamo inviato un'email di verifica a {{email}}. Clicca il link per verificare l'account.",
      "linkExpiredTitle": "Il link di verifica è scaduto.",
      "resendLink": "Reinvia email di verifica",
      "rateLimited": "Troppi tentativi. Attendi 15 minuti prima di richiedere un'altra email.",
      "resendButton": "Reinvia email di verifica",
      "resendButtonDone": "Email di verifica reinviata ✓",
      "footerHint": "Non l'hai ricevuta? Controlla lo spam o richiedi un nuovo link.",
      "testExpired": "(Test: simula token scaduto)"
    },
    "verifyToken": {
      "loadingTitle": "Verifica dell’e-mail",
      "loadingBody": "Attendi mentre confermiamo il tuo account.",
      "successTitle": "E-mail verificata",
      "successBody": "Il tuo account è verificato. Puoi accedere ora.",
      "invalidTitle": "Link di verifica non valido",
      "invalidBody": "Questo link non è valido. Richiedi una nuova e-mail di verifica dalla pagina di accesso.",
      "expiredTitle": "Link di verifica scaduto",
      "expiredBody": "Questo link è scaduto. Richiedi una nuova e-mail di verifica dalla pagina di accesso.",
      "errorTitle": "Verifica non riuscita",
      "errorBody": "Non siamo riusciti a verificare la tua e-mail. Riprova o richiedi un nuovo link.",
      "goToLogin": "Vai all’accesso"
    },
    "verifyEmailChange": {
      "loadingTitle": "Verifica della nuova email in corso",
      "loadingBody": "Attendi mentre confermiamo la richiesta di cambio email.",
      "successTitle": "Email aggiornata con successo",
      "successBody": "Il tuo indirizzo email è stato aggiornato.",
      "successBodyWithEmail": "La tua nuova email di accesso è {{email}}.",
      "invalidTitle": "Link di cambio email non valido",
      "invalidBody": "Questo link di cambio email non è valido o è già stato usato.",
      "expiredTitle": "Link di cambio email scaduto",
      "expiredBody": "Questo link di cambio email è scaduto. Avvia una nuova modifica email da Impostazioni.",
      "errorTitle": "Impossibile verificare il cambio email",
      "errorBody": "Si è verificato un errore durante la verifica del cambio email. Riprova più tardi.",
      "goToLogin": "Vai al login →"
    }
  },
  "common": {
    "search": "Ricerca…",
    "filter": "Filtro",
    "sort": "Ordina",
    "apply": "Applicare",
    "applyWithCount": "Applica ({{count}})",
    "reset": "Reset",
    "clearAll": "Elimina tutto",
    "cancel": "Annulla",
    "close": "Chiudi",
    "loading": "Caricamento in corso…",
    "nameAZ": "Nome A-Z",
    "nameZA": "Nome Z-A",
    "moreFilters": "+{{count}} altro",
    "moreFiltersAria": "{{count}} filtri più attivi — elenco aperto",
    "additionalFilters": "Altri filtri",
    "removeFilterAria": "Rimuovi il filtro {{label}}",
    "loadingRoute": "Caricamento pagina…",
    "loadingContent": "Caricamento contenuto…",
    "loadingTable": "Caricamento tabella…"
  },
  "dashboard": {
    "todaysStats": "STATISTICHE DI OGGI",
    "needsAttention": "%s ha bisogno della tua attenzione.",
    "seeAllChats": "Tutte le chat",
    "badgeEscalated": "Riassegnato",
    "badgeDraftReady": "✏ BOZZA PRONTA",
    "allClear": "Tutto chiaro! Nessuna conversazione attiva in questo momento.",
    "weeklySummary": "Riepilogo settimanale",
    "conversationsByIntent": "Conversazioni per intento",
    "autoVsManual": "Auto-maneggiato vs Manuale",
    "legendAiHandled": "IA gestita",
    "legendManual": "Manuale",
    "relativeJustNow": "Ora",
    "relativeMinsAgo": "{{count}} min fa",
    "relativeOneHourAgo": "1 ora fa",
    "relativeHoursAgo": "{{count}}h fa",
    "relativeOneDayAgo": "1 giorno fa",
    "relativeDaysAgo": "{{count}}d fa",
    "intentApi": {
      "booking": "Prenota",
      "rebooking": "Riprenota",
      "cancellation": "Annulla",
      "info": "Informazioni",
      "schedule": "Allegato",
      "account": "Account",
      "other": "Altro"
    },
    "badgeSessionExpiring": "⏱ SESSIONE",
    "sessionExpiringTileWindow": "La finestra a testo libero si chiude {{time}}",
    "sessionBannerTitle": "Le risposte WhatsApp potrebbero essere limitate a breve",
    "sessionBannerBody": "Almeno una chat in escalation sta per chiudere la finestra a testo libero. Apri Chat per rispondere in tempo.",
    "sessionBannerDismiss": "Nascondi",
    "sessionBannerOpenChats": "Apri chat filtrate",
    "relativeUntilShort": "ancora {{time}}"
  },
  "chats": {
    "loadingChats": "Caricamento chat in corso...",
    "noConversations": "Nessuna conversazione trovata.",
    "noConversationsMatchFilters": "Nessuna conversazione corrisponde alla ricerca o ai filtri.",
    "listLoadFailed": "Impossibile caricare le conversazioni. Riprova.",
    "studioContextRequired": "Il contesto studio non è impostato correttamente. Passa a uno studio specifico o riprova.",
    "studioContextRetry": "Riprova",
    "studioContextSwitchStudio": "Passa a uno studio",
    "unreadConversation": "Conversazione non letta con {{name}}",
    "unreadConversationCount": "Conversazione non letta con {{name}}, {{count}} messaggi non letti",
    "session": {
      "filterBarTitle": "Filtrato: sessione in scadenza",
      "filterBarHint": "Mostra le conversazioni con sessione in chiusura o già scaduta per il testo libero.",
      "clearSessionFilter": "Mostra tutte le chat",
      "filterEmpty": "Nessuna chat corrisponde al filtro sessione in questa vista. Rimuovi il filtro o cambia lo studio.",
      "bannerExpiringTitle": "Sessione WhatsApp in chiusura",
      "bannerExpiringBody": "Le risposte a testo libero restano possibili per {{time}}. Poi Meta può richiedere un modello approvato o un nuovo messaggio del cliente.",
      "bannerExpiredTitle": "Sessione WhatsApp chiusa per il testo libero",
      "bannerExpiredBody": "Questa conversazione è fuori dalla finestra cliente di 24 ore. L’invio può fallire finché non usi un modello approvato o il cliente non scrive di nuovo.",
      "composerExpiredHelp": "Le risposte libere sono bloccate. Scegli un modello di messaggio approvato dal pannello bozze sopra.",
      "composerClosedInstagram": "Sono passati più di 7 giorni. Chiedi al cliente di scriverti di nuovo prima di poter rispondere.",
      "rowAriaExpiringWhatsApp": "Sessione WhatsApp in scadenza",
      "rowAriaExpiredWhatsApp": "Sessione WhatsApp scaduta per il testo libero",
      "rowTooltipExpiringWhatsApp": "La sessione si chiude tra {{time}}",
      "rowTooltipExpiredWhatsApp": "Sessione scaduta — modelli o nuovo messaggio del cliente",
      "rowAriaSessionExpiring": "Sessione di messaggistica in scadenza",
      "rowAriaSessionExpired": "Sessione di messaggistica scaduta per il testo libero",
      "rowTooltipExpiringInstagram": "La finestra di risposta si chiude tra {{time}}",
      "rowTooltipExpiredInstagram": "Oltre 24 h — solo risposte manuali, fino a 7 giorni",
      "bannerExpiringTitleInstagram": "Finestra di risposta in chiusura",
      "bannerExpiringBodyInstagram": "Risposte ancora possibili per {{time}}. Rispondi presto o attendi un nuovo messaggio del cliente.",
      "bannerExpiredTitleInstagram": "Fuori dalla finestra di risposta di 24 ore",
      "bannerExpiredBodyInstagram": "Fuori dalla finestra di 24 ore (fino a 7 giorni): Solo risposta manuale, oppure Rivedi la risposta suggerita, modifica e invia manualmente.",
      "bannerClosedTitleInstagram": "Impossibile rispondere su Instagram",
      "bannerClosedBodyInstagram": "Sono passati più di 7 giorni. Chiedi al cliente di scriverti di nuovo.",
      "headerSupportWindowInstagram": "Finestra supporto · {{time}} fa"
    },
    "customerInfo": "Informazioni sul cliente",
    "customerInfoTitle": "Informazioni sul cliente",
    "details": {
      "title": "Dettagli cliente",
      "show": "Mostra dettagli cliente",
      "hide": "Nascondi dettagli cliente",
      "collapseAria": "Comprimi il pannello dei dettagli cliente",
      "expandAria": "Espandi il pannello dei dettagli cliente",
      "resizeAria": "Ridimensiona il pannello dei dettagli cliente",
      "placeholderLoading": "Caricamento dei dettagli cliente…",
      "sectionGeneral": "Generale",
      "sectionStudios": "Studios",
      "sectionDocuments": "Documenti",
      "sectionClasses": "Corsi",
      "upcomingClassesToggle": "Prossimi corsi più vicini",
      "upcomingClassesEmpty": "—",
      "classesLast": "Ultimo",
      "classesNext": "Prossimo",
      "confirmIdentity": "Conferma identità",
      "confirmIdentityHelp": "Segna questo cliente come identificato in questa chat e sblocca le azioni di approvazione bozza bloccate."
    },
    "composer": {
      "collapseAria": "Comprimi il campo di risposta",
      "expandAria": "Espandi il campo di risposta"
    },
    "escalated": "Riassegnato",
    "escalatedDraftPending": "Risposta suggerita pronta — rivedi prima di inviare",
    "escalationKind": {
      "soft": "Da rivedere",
      "hard": "Presa in carico umana"
    },
    "escalationFamily": {
      "human_requested": "Il cliente ha chiesto una persona",
      "tool_or_platform_failure": "Errore di strumento o piattaforma",
      "availability_unverified": "Disponibilità non verificata",
      "no_availability": "Nessun corso prenotabile",
      "account_read_failed": "Lettura account non riuscita",
      "conversation_stall": "Conversazione bloccata",
      "low_confidence_or_scope": "Fuori ambito o incerto",
      "frustration": "Cliente frustrato",
      "max_exchanges": "Massimo scambi raggiunto",
      "identity_verification": "Verifica identità necessaria",
      "policy_restricted": "Argomento limitato",
      "manual": "Escalato manualmente",
      "ai_unavailable": "IA non disponibile",
      "named_set_unfinished": "Cancellazione non completata",
      "cancellation_refused": "Cancellazione rifiutata"
    },
    "leadWhy": {
      "structured": "Da annuncio",
      "inferred": "Dedotto"
    },
    "campaignLeadPreparation": {
      "title": "Messaggio di benvenuto della campagna preparato",
      "closedTitle": "Episodio della campagna chiuso",
      "activeTitle": "Messaggio di benvenuto della campagna attivo",
      "notSent": "Non inviato",
      "closed": "Chiuso",
      "active": "Attivo",
      "activeBody": "Il provider ha accettato il messaggio di benvenuto della campagna. L’episodio attende la scelta del pacchetto da parte del cliente.",
      "closedBody": "L’automazione della campagna è stata interrotta per questo episodio.",
      "terminal": {
        "purchase_verified": "Acquisto verificato",
        "member_discovered": "Membro esistente trovato",
        "explicit_decline": "Il cliente ha rifiutato",
        "manager_takeover": "Un responsabile ha preso il controllo"
      },
      "awaitingPack": "In attesa della scelta del pacchetto",
      "packSelected": "Pacchetto selezionato: {{name}}",
      "linkReady": "Link di acquisto pronto: {{name}}",
      "purchaseClaimUnverified": "Acquisto segnalato · verifica necessaria",
      "bodyAuto": "I dati della campagna sono fissati. Il messaggio di benvenuto è in coda per l’invio automatico.",
      "bodyManual": "I dati della campagna sono fissati. Controlla e invia il messaggio di benvenuto dalla risposta suggerita qui sotto.",
      "modeAuto": "Preparazione automatica · invio in coda",
      "modeManual": "Preparazione manuale · revisione richiesta",
      "campaign": "{{name}} · versione {{version}}",
      "campaignFallback": "Campagna · versione {{version}}",
      "packs": "Pacchetti preparati",
      "purchaseLink": "Link di acquisto"
    },
    "resolved": "Risolto",
    "resolvedButton": "Contrassegna come risolto",
    "messageDeliveryFailedHumanAgentTitle": "Impossibile inviare questa risposta su Instagram",
    "messageDeliveryFailedHumanAgentBody": "L'agente umano Instagram non è ancora approvato per questa app, quindi questo messaggio non ha potuto raggiungere il cliente. Chiedi al cliente di scriverti di nuovo per riaprire le risposte gratuite, o continua su WhatsApp se è collegato.",
    "messageDeliveryFailedBubble": "Non ha raggiunto il cliente",
    "resolve": "Risolvi",
    "escalate": "Riassegna",
    "archive": "Archivio",
    "moreChatActions": "Altre azioni di chat",
    "chatIdLabel": "ID chat",
    "loadingOlder": "Caricamento messaggi precedenti…",
    "loadOlderMessages": "Carica messaggi precedenti",
    "customerFallback": "Cliente",
    "senderSystem": "Sistema",
    "loadingMessages": "Caricamento messaggi in corso",
    "draftBlockedDefault": "Il cliente deve essere identificato prima di approvare le azioni dell'account.",
    "draftBlockedHumanHandling": "Questa conversazione è già stata affidata al tuo team — questo suggerimento potrebbe rispondere a un messaggio precedente.",
    "draftStaleHeadReleased": "La conversazione è andata avanti da quando è stata scritta questa risposta.",
    "draftStaleHeadReleasedRecovery": "Modificala prima di inviarla, oppure rispondi con parole tue.",
    "draftStaleHeadReleasedRefusal": "Questa risposta suggerita non è più aggiornata — la conversazione è andata avanti da quando è stata scritta. Cambia il testo prima di inviarlo, oppure rispondi con parole tue.",
    "listJustNow": "Ora",
    "listMinsShort": "{{count}}m fa",
    "listHoursShort": "{{count}}h fa",
    "listDaysShort": "{{count}}d fa",
    "threadToday": "Oggi",
    "threadYesterday": "Ieri",
    "emojiSearchPlaceholder": "Cerca emoji",
    "emojiSkinToneAria": "Cambia tonalità pelle emoji",
    "emojiCategoryRecent": "Emoji recenti",
    "emojiCategoryAll": "Tutte le emoji",
    "emojiCategorySmileys": "Faccine e persone",
    "emojiCategoryPeople": "Gesti e persone",
    "emojiCategoryHearts": "Cuori e celebrazioni",
    "emojiCategoryTravel": "Viaggi e luoghi",
    "emojiCategorySymbols": "Simboli e stato",
    "resolvedModalConfirm": "Contrassegna come risolti",
    "typeMessagePlaceholder": "Scrivi un messaggio",
    "editTitle": "Modificare",
    "senderAi": "AI",
    "senderTeam": "Team",
    "connectPlatformHint": "Collega una piattaforma di prenotazione {{listingFragment}} in Impostazioni → Canali per mostrare il contesto dei membri o degli ospiti collegati qui.",
    "connectPlatformListingFragment": "o annuncio",
    "connectPlatformListingEmpty": "",
    "searchManually": "Cerca manualmente",
    "trial": "Periodo di prova",
    "firstTrial": {
      "staffHint": {
        "scenario1": "Prima prova — scenario 1 (nessun account sulla piattaforma di prenotazione). Solo per il team.",
        "scenario2": "Prima prova — scenario 2 (account esistente, nuovo nel tuo studio). Solo per il team."
      },
      "linksNotReady": {
        "title": "Link per la prima prova mancante",
        "reason": {
          "missing_trial_registration_link": "Aggiungi il link di registrazione / prova prima che Copilot possa inviare automaticamente questo percorso di prova.",
          "missing_studio_trial_booking_link": "Aggiungi il link dello studio prima che Copilot possa inviare automaticamente questo percorso di prova.",
          "unknown": "Aggiungi i link richiesti per la prima prova prima che Copilot possa inviare automaticamente questo percorso di prova."
        },
        "cta": "Apri Info generali"
      }
    },
    "completedWriteClash": {
      "title": "La bozza contraddice un'azione già completata",
      "body": "La piattaforma di prenotazione conferma che questa azione è stata completata in questo turno, ma la bozza dice ancora al cliente che non ne ha diritto. Modifica la risposta prima di approvarla."
    },
    "groundedFailure": {
      "title": "La risposta basata sui fatti deve essere verificata",
      "facts": "Fatti trovati",
      "reason": "Problema di verifica"
    },
    "proposedAction": {
      "FIRST_TRIAL_LINKS_NOT_READY": "Configura i link di prova in Dati dello studio prima che Copilot possa inviare automaticamente questo percorso di prova.",
      "GROUP_MANUAL_FULFILLMENT": "Le prenotazioni di gruppo o team richiedono l’evasione manuale da parte del team dello studio."
    },
    "campaignSend": {
      "campaign_ended": "Questa campagna è terminata o non è più attiva, quindi il messaggio di benvenuto non è stato inviato.",
      "instagram_window_closed": "La finestra di risposta Instagram per questo cliente è chiusa, quindi il messaggio di benvenuto non è stato inviato.",
      "human_handling": "Un membro del team ha preso in carico questa conversazione, quindi il messaggio di benvenuto della campagna non è stato inviato.",
      "customer_is_member": "Questo cliente è già un membro, quindi il messaggio di benvenuto della campagna non è stato inviato.",
      "newer_customer_message": "Il cliente ha scritto di nuovo dopo la preparazione di questo messaggio di benvenuto, quindi non è stato inviato.",
      "campaign_paused": "L’invio delle campagne è al momento in pausa per questo studio, quindi il messaggio di benvenuto non è stato inviato.",
      "instagram_not_connected": "Non è stato possibile confermare la connessione Instagram di questo studio. Controlla la connessione nelle Impostazioni, poi riprova.",
      "send_in_progress": "Un altro invio per questo cliente è ancora in corso. Attendi che finisca prima di riprovare; può richiedere un minuto.",
      "cooldown_or_capacity": "Questo cliente ha raggiunto per ora il limite di messaggi di benvenuto della campagna, quindi il messaggio non è stato inviato.",
      "draft_changed": "Questa bozza non corrisponde più al messaggio di campagna preparato. Aggiorna la conversazione prima di riprovare.",
      "group_booking_active": "In questa conversazione è ancora aperta una proposta di prenotazione di gruppo, quindi il messaggio di benvenuto della campagna non è stato inviato. Risolvi o scarta prima quella proposta.",
      "no_customer_message": "In questa conversazione non c’è ancora nessun messaggio del cliente, quindi il messaggio di benvenuto della campagna non è stato inviato.",
      "internal": "Non è stato possibile inviare il messaggio di benvenuto della campagna perché un controllo interno non è riuscito. Riprova più tardi o contatta il supporto.",
      "customer_refused": "Questo cliente ha rifiutato la campagna, quindi non è stato inviato alcun messaggio di benvenuto.",
      "customer_reply_pending_check": "L’ultima risposta del cliente è ancora in corso di verifica, quindi il messaggio di benvenuto non è stato ancora inviato. Riprova tra un attimo.",
      "campaign_updated": "La campagna è stata modificata dopo la preparazione di questo messaggio di benvenuto, quindi non è stato ancora inviato. Il messaggio ora corrisponde all’offerta attuale. Controllalo, poi premi di nuovo Invia.",
      "campaign_updated_edited": "La campagna è stata modificata dopo la preparazione di questo messaggio di benvenuto, quindi non è stato ancora inviato. Il tuo testo modificato è stato mantenuto. Controlla pacchetti e prezzi, poi premi di nuovo Invia.",
      "welcome_too_long": "Questo messaggio di benvenuto è troppo lungo per un unico messaggio Instagram, quindi non è stato inviato. Accorcialo, poi premi di nuovo Invia.",
      "welcome_capacity_reached": "Questo cliente ha già ricevuto il massimo di due messaggi di benvenuto della campagna da questo studio, quindi il messaggio non è stato inviato.",
      "welcome_cooldown_active": "Questo cliente ha ricevuto un messaggio di benvenuto della campagna da questo studio negli ultimi 30 giorni, quindi il messaggio non è stato inviato. Un nuovo messaggio di benvenuto sarà possibile dopo i 30 giorni.",
      "campaign_episode_active": "Una conversazione della campagna con questo cliente è ancora in corso, quindi non è stato inviato un secondo messaggio di benvenuto.",
      "campaign_episode_ended": "Una precedente conversazione della campagna con questo cliente è già terminata, quindi il messaggio di benvenuto non è stato inviato.",
      "welcome_delivery_unknown": "Un invio precedente di questo messaggio di benvenuto potrebbe aver già raggiunto il cliente, quindi non è stato inviato di nuovo."
    },
    "confirmObject": {
      "cardTitleBooking": "Prenotazione da confermare",
      "cardTitleCancel": "Cancellazione da confermare",
      "cardTitleRebook": "Annulla e prenota",
      "cardTitleIdentity": "Identità da confermare",
      "customerLabel": "Cliente",
      "classLabel": "Lezione",
      "classIdLabel": "Id lezione",
      "dateLabel": "Data",
      "timeLabel": "Ora",
      "instructorLabel": "Istruttore",
      "bookingRefLabel": "Rif. prenotazione",
      "rebookFromLabel": "Annulla",
      "rebookToLabel": "Prenota",
      "cancelSetAnd": "e",
      "cancelSetUnknownClass": "Un corso (dettagli non disponibili)",
      "contactLabel": "Contatto",
      "contactMissing": "Nessuna e-mail, telefono o handle Instagram in questa chat.",
      "itineraryPartial": "Nome della lezione, data e ora locale non sono ancora in questo payload. Conferma esegue comunque la scrittura approvata.",
      "confirmBooking": "Conferma prenotazione",
      "confirmCancellation": "Conferma cancellazione",
      "confirmRebook": "Conferma annulla e prenota",
      "confirmIdentity": "Conferma identità",
      "abort": "Annulla",
      "abortUnavailable": "Lo scarto non è ancora disponibile. Conferma esegue comunque; nascondere questa scheda non annullerebbe la scrittura in sospeso.",
      "bookingInProgress": "Prenotazione in corso…",
      "bookingStillRunning": "La prenotazione è ancora in corso. Puoi continuare in altre chat; il risultato apparirà qui.",
      "abortIdentityHint": "Non conferma l’identità. Nessuna richiesta viene inviata.",
      "claimLive": "{{name}} sta completando questa operazione adesso. Conferma e Annulla sono temporaneamente bloccati.",
      "claimLiveNoName": "Un altro manager sta completando questa operazione adesso. Conferma e Annulla sono temporaneamente bloccati.",
      "claimStale": "L’ultimo tentativo non è stato completato. Puoi riprovare."
    },
    "groupBooking": {
      "listBadgeAria": "Richiesta di gruppo o team",
      "listTooltip": "Questa conversazione ha una bozza in sospeso per una richiesta di prenotazione a forma di gruppo o evento di team.",
      "draftCardTitle": "Gruppo / team",
      "cardTitle": "Gruppo / team",
      "extractedPartySize": "Partecipanti indicati: {{count}}",
      "partySize": "Partecipanti indicati: {{count}}",
      "participantsLabel": "Partecipanti",
      "checklistLabel": "Checklist per il manager",
      "checklistUnknown": "Voce: {{key}}",
      "overrideReasonUnknown": "{{key}}",
      "status": {
        "collecting": "Raccolta dati della lista partecipanti",
        "awaitingManager": "In attesa di revisione del manager",
        "awaitingApproval": "In attesa della tua approvazione",
        "running": "Automazione in corso",
        "done": "Completato",
        "failed": "Automazione non riuscita",
        "manualFallback": "Gestione manuale richiesta",
        "notApplicable": "Non applicabile"
      },
      "checklist": {
        "party_size": "Chiarire numero finale e fasce d’età",
        "date_window": "Confermare date preferite o finestra oraria",
        "offering_type": "Confermare tipo di corso, pacchetto o ambito noleggio privato",
        "deposit_or_po": "Caparra, ordine d’acquisto o contatto di fatturazione se applicabile",
        "bill_to": "Entità di fatturazione e dati fiscali se richiesti",
        "roster_complete": "Confermare che la lista partecipanti è completa (nomi e contatti)",
        "class_slot": "Confermare corso, sessione o fascia oraria",
        "book_without_product": "Registrare prenotazione senza prodotto collegato se necessario",
        "invoice_externally": "Fatturare fuori piattaforma se richiesto",
        "terms_confirm_on_site": "Confermare termini e policy in sede se necessario"
      },
      "overrideReason": {
        "group_policy_overrode_auto_send": "L’invio automatico è stato sostituito per questo turno dalla politica gruppo / team — controlla prima di inviare."
      }
    },
    "escalateModalTitle": "Escalation della conversazione",
    "escalateModalBody": "Questo avviserà il team per il follow-up manuale.",
    "resolvedModalTitle": "Contrassegna come risolto",
    "resolvedModalBody": "Questa conversazione sarà contrassegnata come risolta.",
    "filter": {
      "panelTitle": "Filtro",
      "panelDescription": "Seleziona i filtri della chat e applicali all'elenco delle conversazioni.",
      "closeAria": "Chiudi il pannello del filtro",
      "sectionStatus": "STATO",
      "sectionIntention": "Intenzione",
      "sectionCustomerId": "ID CLIENTE",
      "sectionChannel": "CHANNEL",
      "statusUnread": "Non letto",
      "statusNeedsReview": "Occorre revisione",
      "statusEscalated": "Riassegnato",
      "statusAiHandled": "IA gestita",
      "statusResolved": "Risolto",
      "statusNeedsFollowup": "necessario successivo controllo."
    },
    "sort": {
      "newest": "Prima il più nuovo",
      "oldest": "Meno recenti prima",
      "unreadFirst": "Prima non letto",
      "escalatedFirst": "Inoltrato per primo",
      "sessionExpiringFirst": "Urgenza sessione",
      "byStatus": "Stato"
    },
    "intentChip": {
      "newBooking": "nuova prenotazione",
      "rebooking": "CAMBIO DI PRENOTAZIONE",
      "cancellation": "Cancellazione",
      "generalInfo": "Informazioni generali",
      "schedule": "Allegato",
      "membership": "Tesseramento",
      "other": "Altro"
    },
    "customerId": {
      "identified": "Identificato",
      "idPending": "ID in sospeso",
      "unmatched": "Senza accoppiamento",
      "generalInquiry": "Richieste di informazioni generali"
    },
    "leadBadge": {
      "label": "Lead"
    },
    "channel": {
      "instagram": "Instagram",
      "whatsapp": "WhatsApp",
      "facebook": "Facebook Messenger",
      "email": "E-mail"
    },
    "email": {
      "from": "Da",
      "to": "A",
      "cc": "Cc",
      "authorCustomer": "Cliente",
      "subject": "Oggetto",
      "sendFromMailbox": "Le risposte vengono inviate da {{mailbox}}",
      "emptyConnectHint": "Collega l'e-mail in Impostazioni → Canali o dall'intestazione per vedere i thread qui.",
      "deliveryFailed": "Consegna non riuscita",
      "showPreviousMessages": "Mostra messaggi precedenti",
      "hidePreviousMessages": "Nascondi messaggi precedenti",
      "inlineImageUnavailable": "Immagine inline non disponibile",
      "attachmentDownloadFailed": "Impossibile scaricare l'allegato",
      "grantExpiredBannerTitle": "Riconnessione e-mail richiesta",
      "grantExpiredBannerBody": "L'invio è disabilitato finché non riconnetti la casella.",
      "grantExpiredBannerCta": "Apri Impostazioni → Canali",
      "grantExpiredComposer": "Riconnetti l'e-mail in Impostazioni per inviare messaggi.",
      "composer": {
        "send": "Invia",
        "replyAll": "Rispondi a tutti",
        "bold": "Grassetto",
        "italic": "Corsivo",
        "underline": "Sottolineato",
        "bulletList": "Elenco puntato",
        "numberedList": "Elenco numerato",
        "link": "Inserisci link",
        "insertImage": "Inserisci immagine",
        "attachFile": "Allega file",
        "bodyAria": "Corpo del messaggio e-mail",
        "linkPrompt": "Inserisci URL del link",
        "linkUrlInvalid": "Inserisci un indirizzo web valido (es. example.com)",
        "imageTypeError": "Scegli un file immagine",
        "attachmentMaxCount": "Massimo {{count}} allegati",
        "attachmentOversize": "Allegato troppo grande",
        "attachmentUploadFailed": "Caricamento allegato non riuscito",
        "attachmentRemoveFailed": "Impossibile rimuovere l'allegato",
        "inlineImageNotReady": "L'immagine incorporata non è pronta per l'invio. Attendi se un caricamento è in corso, oppure rimuovila e riprova.",
        "removeAttachment": "Rimuovi {{name}}",
        "bodyCharCount": "{{count}} / {{max}} caratteri"
      }
    },
    "provenance": {
      "autoAi": "Auto AI",
      "approvedAi": "IA approvata",
      "team": "Team",
      "sessionNudge": "OktoGo — sollecito di sessione"
    },
    "infoRow": {
      "phone": "Telefono",
      "instagram": "Instagram",
      "email": "E-mail"
    },
    "handling": {
      "autoSendAll": "Tutti gli argomenti: invio automatico",
      "autoSendNone": "Tutti gli argomenti: bozza per approvazione",
      "autoSendMixed": "Misto: alcuni si inviano automaticamente, altri hanno bisogno di approvazione",
      "teamStyleOn": "Stile team",
      "teamStyleOff": "Stile team",
      "autoLabelPrefix": "Etichetta automatica: {{label}}",
      "tooltip": "Come AI gestisce questo thread in OktoGo. La distribuzione del canale utilizza ancora il tuo account aziendale WhatsApp o Instagram collegato."
    },
    "archiveChatError": "Impossibile archiviare la chat",
    "archiveChatSuccess": "Chat archiviata",
    "archiveDialogTitle": "Archiviare chat?",
    "archiveDialogBody": "Sei sicuro di voler archiviare?",
    "archiveDangerTitle": "Zona di pericolo",
    "archiveDangerBody": "Questa azione è irreversibile nell'app. La conversazione verrà rimossa dall'elenco delle chat e i membri del team non la vedranno più qui. La cronologia dei messaggi viene conservata per la conformità, ma potrebbe non essere accessibile da questa interfaccia.",
    "archiveAnyway": "Archivia comunque",
    "customerWroteAgain": {
      "notice": "Il cliente ha scritto di nuovo. Questa conferma non è più attiva. L'assistente sta leggendo il suo messaggio."
    },
    "emptyStateTitle": "Seleziona una conversazione",
    "emptyStateSubtitle": "Scegli dall'elenco per visualizzare i messaggi",
    "saveEdit": "Salva",
    "messageEdited": "modificato",
    "attachmentPhotoVideo": "Foto/Video",
    "attachmentDocument": "Document",
    "attachmentUpload": "Carica file",
    "noMessages": "Nessun messaggio da visualizzare.",
    "draftApproveSend": "Invia",
    "identityPendingHint": "Identità in sospeso —",
    "identityApprovalSuccess": "Identità confermata. Ora puoi approvare e inviare la bozza.",
    "identityVerifiedMilestone": "Identità verificata",
    "identityApprovalFailed": "Non siamo riusciti a confermare l’identità. Riprova tra un attimo.",
    "identityApprovalNotAvailable": "Nessun profilo cliente collegato al momento. Attendi la conferma del cliente o collega prima un profilo, poi riprova.",
    "identityInvalidState": "L’identità non è in attesa di approvazione per questa conversazione. Aggiorna e riprova.",
    "draftEdit": "Modificare",
    "draftDeliveredDiffers": "Il testo inviato è diverso dalla bozza approvata.",
    "draftRegenerate": "Rigenerazione",
    "draftAbortFailed": "Non siamo riusciti a scartare questa azione in sospeso. Riprova tra un attimo.",
    "reject": "Rifiuta",
    "reportIssue": "Segnala problema",
    "reportCopilotIssueMenu": "Segnala problema Copilot",
    "feedback": {
      "dialogTitleReject": "Rifiuta risposta suggerita",
      "dialogTitleReport": "Segnala problema Copilot",
      "dialogDescriptionReject": "Dicci cosa non ha funzionato. La risposta suggerita verrà rimossa dopo l’invio.",
      "dialogDescriptionReport": "Descrivi il problema. La tua risposta suggerita resterà disponibile per modificarla o inviarla.",
      "categoryLegend": "Qual era il problema?",
      "categoryRequired": "Scegli una categoria per continuare.",
      "category": {
        "wrongInformation": "Informazione errata o obsoleta",
        "wrongTone": "Tono o formulazione sbagliati",
        "shouldHaveAsked": "Avrebbe dovuto chiedermelo prima",
        "bookingMistake": "Errore di prenotazione",
        "misunderstood": "Richiesta fraintesa",
        "other": "Altro"
      },
      "detailsLabel": "Dettagli (facoltativo)",
      "detailsPlaceholder": "Cosa avrebbe dovuto fare Copilot?",
      "includeContext": "Includi contesto conversazione",
      "piiWarning": "Non allegare screenshot con numeri di telefono o dati di pagamento dei clienti.",
      "wrongInformationHint": "Puoi aggiornare i dati dello studio in",
      "studioDataLink": "Dati studio",
      "cancel": "Annulla",
      "submitReject": "Rifiuta",
      "submitReport": "Invia segnalazione",
      "submitting": "Invio…",
      "submitThanks": "Grazie — il tuo feedback ci aiuta a migliorare Copilot.",
      "errorGeneric": "Impossibile inviare il feedback. Riprova.",
      "errorNoPendingDraft": "Non c’è una bozza in sospeso da rifiutare.",
      "errorRateLimited": "Hai inviato diverse segnalazioni di recente. Attendi qualche minuto.",
      "errorForbidden": "Non hai il permesso di inviare feedback per questa chat.",
      "reportedDraftLabel": "Risposta suggerita segnalata",
      "errorAttachmentUpload": "Impossibile caricare l’immagine. Riprova.",
      "errorUnsupportedFileType": "Tipo di file non supportato",
      "attachmentsLabel": "Screenshot (facoltativo)",
      "addAttachment": "Aggiungi immagine",
      "attachmentOversize": "Ogni immagine deve essere di 2 MB o meno.",
      "attachmentMaxCount": "Puoi allegare fino a 3 immagini.",
      "attachmentsDropHint": "Incolla o trascina qui le immagini (PNG, JPEG, WebP; max 2 MB ciascuna).",
      "scenarioSuggestedLegend": "Scenario di test (suggerito)",
      "scenarioConfidence": "Affidabilità: {{level}}",
      "scenarioConfidenceHigh": "Alta",
      "scenarioConfidenceMedium": "Media",
      "scenarioConfidenceLow": "Bassa",
      "scenarioChange": "Modifica",
      "scenarioSkipMapping": "Non sono sicuro / salta mappatura",
      "scenarioNoSuggestion": "Nessuna corrispondenza automatica per questa categoria. Scegli manualmente o salta.",
      "scenarioPickManual": "Scegli scenario"
    },
    "whatsappTemplatePicker": {
      "title": "Seleziona modello approvato",
      "aria": "Seleziona modello approvato",
      "searchPlaceholder": "Cerca modelli di messaggio…",
      "select": "Seleziona",
      "insert": "Inserisci",
      "inWindowHint": "Il testo del modello verrà inserito nella bozza. Invialo con Approva e invia come al solito."
    },
    "whatsappTemplate": {
      "panelTitle": "Modello di messaggio",
      "panelSubtitle": "Fuori dalla finestra di 24 ore, solo i modelli approvati da Meta possono raggiungere il cliente.",
      "loading": "Caricamento modelli…",
      "loadError": "Impossibile caricare i modelli WhatsApp.",
      "retry": "Riprova",
      "emptyApproved": "Nessun modello approvato per questo studio. Aggiungi o fai approvare modelli in Impostazioni → Canali.",
      "templateLabel": "Modello",
      "templatePlaceholder": "Scegli un modello",
      "variableLabel": "Variabile {{index}}",
      "variableCountError": "Questo modello richiede {{count}} variabile/i.",
      "previewLabel": "Anteprima",
      "sendButton": "Invia modello",
      "sendSuccess": "Messaggio modello accodato.",
      "sendError": "Impossibile inviare il modello. Riprova.",
      "approveBlockedTooltip": "L’approvazione in testo libero è bloccata. Invia un modello WhatsApp approvato qui sotto.",
      "suggestedLabel": "Suggerito per questa conversazione",
      "llmSuggestedHelper": "Suggerito dall’IA per questa conversazione.",
      "suggestionRationale": {
        "supportFollowup": "Follow-up su un messaggio cliente recente",
        "aiHandoff": "Passaggio a un membro del team dopo escalation",
        "bookingCancelled": "Contesto cancellazione prenotazione",
        "classReminder": "Promemoria corso o prenotazione",
        "bookingConfirmed": "Conferma prenotazione",
        "waitlist": "Posto in lista d’attesa disponibile",
        "reengagement": "Riattivazione dopo risoluzione"
      }
    },
    "insertMessage": {
      "chooseTemplate": "Scegli modello di messaggio"
    },
    "messageTemplate": {
      "panelTitle": "Modello di messaggio",
      "expiredEmptyTitle": "Finestra di messaggistica chiusa",
      "expiredEmptyBody": "Scegli un modello WhatsApp approvato per raggiungere questo cliente.",
      "editVariables": "Modifica variabili"
    },
    "feedbackEditor": {
      "bold": "Grassetto",
      "italic": "Corsivo",
      "bulletList": "Elenco puntato",
      "orderedList": "Elenco numerato",
      "emoji": "Inserisci emoji",
      "markdownHint": "La formattazione usa Markdown. Usa Anteprima per vedere il risultato.",
      "showPreview": "Anteprima",
      "hidePreview": "Modifica"
    },
    "draftRegenerateTitle": "Rigenerazione",
    "draftAiDraft": "Risposta suggerita",
    "draftReviewing": "Risposta suggerita — in revisione",
    "draftReview": "Rivedi",
    "composeManualReply": "Risposta manuale",
    "composeManualReplyPlaceholder": "Scrivi il messaggio manualmente",
    "draftSave": "Salva bozza",
    "draftRegenerateFailed": "Rigenerazione fallita.",
    "draftRegenerateFailedRetry": "Rigenerazione non riuscita. Riprova.",
    "draftRegenerateWsFailed": "Rigenerazione bozza non riuscita.",
    "replySendFailed": "Non siamo riusciti a inviare il messaggio: lo abbiamo rimesso nel campo di scrittura. Riprova tra un momento.",
    "replyTooLong": "Questo messaggio è troppo lungo per essere inviato. Accorcialo oppure allega il testo come file.",
    "replyTooLongDelta": "Questo messaggio supera il limite di {{over}} caratteri. Accorcialo oppure allega il testo come file.",
    "actionLogExpand": "Espandi registro azioni AI",
    "actionLogCollapse": "Comprimi registro azioni AI",
    "actionLogTitle": "Action Log",
    "actionLogCountOne": "{{count}} azione",
    "actionLogCountOther": "{{count}} azioni",
    "actionLogAttribution": "da {{name}}",
    "actionLogLabels": {
      "draft_approved": "Bozza approvata e inviata",
      "draft_edited": "Bozza modificata",
      "draft_edited_and_sent": "Bozza modificata e inviata",
      "draft_regenerated": "Bozza rigenerata",
      "draft_aborted": "Bozza interrotta prima dell'invio",
      "manual_reply_sent": "Risposta manuale inviata",
      "whatsapp_template_sent": "Modello WhatsApp inviato",
      "auto_reply_sent": "Risposta automatica inviata",
      "status_changed": "Stato modificato",
      "identity_approved": "Identità confermata",
      "faq_created": "FAQ creata",
      "faq_edited": "FAQ modificata",
      "faq_deleted": "FAQ eliminata",
      "toggle_changed": "Impostazione modificata",
      "menu_answered": "Menu risposto"
    },
    "registrationTitle": "Data",
    "registrationSendLink": "Link di registrazione",
    "registrationAssisted": "Registrazione assistita",
    "registrationSendLinkButton": "Invia collegamento",
    "refundApplicable": "Ancora in tempo — il credito o il pass dovrebbe tornare.",
    "refundNotApplicable": "Troppo vicino all'inizio del corso — non torna nessun credito.",
    "richCards": {
      "availabilitySpots": "{{spots}} posti",
      "availabilitySpotsWarning": "{{spots}} posti ⚠️",
      "bookingNoFee": "Nessuna commissione addebitata",
      "bookingNewClient": "Nuovo account cliente creato",
      "bookingConfirmedTitle": "Prenotazione confermata",
      "bookingCreditsLine": "Crediti usati: {{used}} · Rimanenti: {{remaining}}",
      "rebookingCancelled": "Annullata",
      "rebookingRebooked": "Riprenotata",
      "policyRequiredNotice": "Preavviso richiesto: {{value}}",
      "policyTimeUntilClass": "Tempo alla lezione: {{value}}",
      "policyLateFee": "Penale per ritardo: {{value}}",
      "scheduleStatusOpen": "Aperto",
      "multiBookedTitle": "{{count}} lezioni prenotate",
      "membershipLabel": "Abbonamento: {{name}}",
      "membershipUsedProgress": "{{used}} / {{total}} usati",
      "membershipRemaining": "Rimanenti: {{remaining}}",
      "membershipExpires": "Scadenza: {{date}} ({{days}} giorni)",
      "membershipBookNext": "Prenota la prossima lezione",
      "membershipRenew": "Rinnova — {{label}} {{price}}"
    },
    "customerPanel": {
      "noListingChannel": "Nessun canale dell'annuncio collegato",
      "noBookingPlatform": "Nessuna piattaforma di prenotazione connessa",
      "memberCustomerId": "ID membro / cliente",
      "secondaryReference": "Riferimento secondario",
      "noMatchingGuest": "Nessun record ospite corrispondente",
      "noMatchingCustomer": "Nessun record cliente corrispondente",
      "joinedLineStr": "{{line}} · {{platform}}",
      "guestNotFoundIn": "Ospite non trovato in {{platform}}",
      "connectedPlatform": "Connesso · {{platform}}",
      "eversportsCustomerId": "ID cliente Eversports",
      "genericCustomerId": "{{platform}} ID cliente",
      "mindbodyClientId": "ID cliente Mindbody",
      "bsportMemberId": "ID membro Bsport",
      "partnerNetworkId": "rete di partner",
      "customerNotFoundIn": "Cliente non trovato in {{platform}}"
    }
  },
  "studioData": {
    "activeStudioLimitReached": "Massimo 5 studi attivi. Archivia uno studio prima di crearne un altro.",
    "readOnlyBanner": "Ha accesso in sola lettura a {{noun}}.",
    "noStudiosLinked": "Nessuno studio collegato a questo account.",
    "notConfiguredTab": "Non configurata",
    "searchStudiosAria": "Cerca studi",
    "tabClasses": "Classi",
    "tabFaq": "Faq",
    "tabGeneral": "Informazioni generali",
    "tabPolicies": "Politiche",
    "tabPrices": "Prezzi",
    "tabTeam": "Team",
    "tabUsers": "Utenti",
    "tabCampaigns": "Campagne",
    "readOnlyHint": "Solo i proprietari e i manager possono modificarlo.",
    "import": {
      "action": "Importa",
      "actionEmpty": "Importa da documento",
      "titleFaq": "Importa nelle FAQ",
      "titlePolicies": "Importa nelle policy",
      "titleGeneral": "Importa nelle info generali",
      "tabPaste": "Incolla testo",
      "tabUpload": "Carica file",
      "uploadComingSoon": "Il caricamento file arriverà presto. Incolla il testo per ora.",
      "pastePlaceholder": "Incolla qui manuale, pagina FAQ o documento policy…",
      "pasteHint": "Suggeriremo voci strutturate. Nulla viene salvato finché non rivedi e applichi.",
      "pasteCharCount": "{{count}} / {{max}} caratteri (minimo {{min}})",
      "continue": "Continua",
      "processing": "Lettura del documento…",
      "reviewTitle": "Rivedi importazione",
      "reviewSummary": "{{faq}} FAQ · {{policies}} policy · {{general}} campi generali proposti",
      "reviewSummaryGeneral": "{{general}} campi generali proposti",
      "reviewSummaryFaq": "{{faq}} FAQ proposte",
      "reviewSummaryPolicies": "{{policies}} policy proposte",
      "warningsHeading": "Note dall'importazione",
      "reviewEmpty": "Niente di nuovo da aggiungere da questo documento.",
      "addSelected": "Aggiungi selezionati ({{count}})",
      "back": "Indietro",
      "lowConfidence": "Bassa affidabilità — verifica prima di applicare",
      "conflictFaq": "FAQ simile esistente: {{question}}",
      "conflictPolicy": "Policy simile esistente: {{title}}",
      "faqCapBanner": "Solo {{allowed}} FAQ su {{selected}} possono essere aggiunte (max 50 per studio)",
      "successFaq": "Aggiunte {{count}} FAQ",
      "successPolicies": "Aggiunte {{entries}} policy e {{overrides}} override",
      "successGeneral": "Aggiornati {{count}} campi generali",
      "successMixed": "Importazione applicata con successo",
      "applyPartial": "{{applied}} applicati. {{failed}} non applicati. Controlla le righe evidenziate.",
      "rowApplyFailed": "Questa voce non è stata applicata. Controlla il valore e riprova.",
      "selectProposal": "Seleziona proposta",
      "sourceExcerpt": "Estratto sorgente",
      "policyOverrideLabel": "Applica come override per {{section}}",
      "openingHoursStructured": "Verranno applicati orari strutturati",
      "generalField": {
        "description": "Descrizione",
        "address": "Indirizzo",
        "directions": "Indicazioni",
        "firstVisitInfo": "Info prima visita",
        "facilities": "Servizi",
        "openingHours": "Orari di apertura",
        "phone": "Telefono principale",
        "email": "E-mail principale",
        "website": "Sito web",
        "mapsLink": "Link Google Maps"
      },
      "upload": {
        "dropHint": "Trascina un file qui o scegline uno",
        "chooseFile": "Scegli file",
        "removeFile": "Rimuovi file",
        "pasteInstead": "Incolla il testo invece",
        "extracting": "Estrazione del testo…",
        "pdfDisclaimer": "L'estrazione PDF può omettere tabelle o pagine scansionate. Controlla le proposte."
      },
      "errors": {
        "generic": "Importazione non riuscita. Riprova.",
        "PREVIEW_EXPIRED": "Anteprima scaduta. Incolla di nuovo il testo.",
        "FAQ_LIMIT_REACHED": "Limite FAQ raggiunto per questo studio.",
        "POLICY_LIMIT_REACHED": "Limite policy raggiunto per questo studio.",
        "VALIDATION_ERROR": "Alcune voci non sono state applicate.",
        "EXTRACTION_FAILED": "Impossibile estrarre il contenuto.",
        "PREVIEW_TIMEOUT": "Elaborazione troppo lunga. Prova un documento più breve.",
        "RATE_LIMITED": "Troppi tentativi. Attendi.",
        "RATE_LIMIT_EXCEEDED": "Troppi tentativi. Attendi.",
        "KNOWLEDGE_IMPORT_DISABLED": "Importazione temporaneamente non disponibile.",
        "FILE_TOO_LARGE": "File troppo grande (max 5 MB).",
        "UNSUPPORTED_FILE_TYPE": "Tipo di file non supportato.",
        "EXTRACTION_EMPTY": "Nessun testo estratto da questo file.",
        "PASSWORD_PROTECTED_FILE": "File protetto da password."
      }
    },
    "addNewUnit": "Aggiungi nuovo studio",
    "archiveSuccess": "Studio archiviato.",
    "archiveError": "Impossibile archiviare studio.",
    "notConfiguredShort": "Connettiti",
    "noStudiosFound": "Nessun monolocale trovato.",
    "noSearchMatch": "Nessun monolocale corrisponde alla tua ricerca.",
    "backToStudioList": "Torna all'elenco degli studi",
    "showStudioList": "Mostra elenco studio",
    "expandDetailFullWidth": "Espandi i dettagli dello studio a larghezza intera",
    "fullWidthTooltip": "A tutto schermo",
    "collapseDetailDefaultWidth": "Torna alla larghezza predefinita",
    "moreStudioActionsAria": "Altre azioni dello studio",
    "studioIdLabel": "ID studio",
    "archiveMenuItem": "Archivio",
    "archiveStudioTitle": "Archive studio",
    "archiveStudioConfirm": "Sei sicuro di voler archiviare",
    "dangerZone": "Zona di pericolo",
    "archiveStudioDangerBody": "Lo studio verrà spostato in Archivio e nascosto dalle liste Studio Data attive.",
    "archiveAnyway": "Archivia comunque",
    "sync": {
      "syncAll": "Sincronizza tutti i dati",
      "syncPricing": "Sincronizza prezzi",
      "syncClasses": "Sincronizza lezioni",
      "syncSchedule": "Sincronizza il calendario",
      "syncTeam": "Sincronizza team",
      "blockLabel": "Sincronizza {{block}}",
      "syncing": "Sincronizzazione…",
      "lastSynced": "Ultima sincronizzazione: {{time}}",
      "error": "Sincronizzazione non riuscita. Riprova.",
      "retry": "Riprova"
    },
    "tabs": {
      "campaigns": {
        "intro": "Quando qualcuno ti scrive da uno dei tuoi annunci Instagram, l'assistente può accoglierlo con l'offerta pubblicizzata da quell'annuncio. Configura le tue campagne qui sotto.",
        "addCampaign": "Aggiungi campagna",
        "groupCurrent": "Attuali",
        "groupPast": "Campagne passate ({{count}})",
        "rowSummary": "{{packs}} pacchetti · {{ads}} annunci",
        "allAdsWord": "tutti",
        "statusActiveChip": "Attiva · termina il {{date}}",
        "statusEndingSoonChip": "In scadenza · termina il {{date}}",
        "statusScheduledChip": "Programmata · inizia il {{date}}",
        "statusExpiredChip": "Scaduta · terminata il {{date}}",
        "statusNotReadyChip": "Non pronta",
        "versionConflict": "Questa campagna è stata modificata in un’altra sessione. Controlla la campagna aggiornata e riprova.",
        "readinessTitle": "Prontezza",
        "readyChip": "Pronta",
        "openAiBehaviour": "Apri comportamento IA",
        "endDateMissingHelper": "Quando termina questa campagna pubblicitaria? L'assistente smette di accogliere nuovi contatti dopo quella data, così non devi ricordarti di disattivarla.",
        "allAdsNote": "Ogni annuncio riceverà questa offerta — scegli questa opzione solo se tutti i tuoi annunci attuali riguardano questa offerta.",
        "toastCreateFailed": "Impossibile creare la campagna.",
        "toastSaveFailed": "Salvataggio non riuscito.",
        "loadError": "Non è stato possibile caricare le campagne.",
        "loadErrorRetry": "Riprova",
        "empty": {
          "title": "Ancora nessuna campagna",
          "body": "Una campagna raggruppa gli annunci, i pacchetti di prova e le date di un'offerta. Aggiungine una per iniziare."
        },
        "missing": {
          "template": "Testo di benvenuto: non ancora impostato da OktoGo",
          "packs": "Aggiungi almeno un pacchetto",
          "pack_link": "A un pacchetto manca un link d'acquisto",
          "eligible_ads": "Scegli quali annunci portano qui",
          "valid_to": "Data di fine mancante",
          "ad_conflict": "Conflitto di annunci"
        },
        "welcomeMessage": {
          "title": "Messaggio di benvenuto",
          "hint": "Un unico messaggio di benvenuto per tutte le campagne · il primo messaggio che riceve un nuovo lead, con i pacchetti di questa campagna",
          "placeholder": "Scrivi il messaggio che un nuovo lead riceve per primo…",
          "tabEdit": "Modifica",
          "tabPreview": "Anteprima",
          "tokenHint": "Mantieni {{packs}} nel testo — viene sostituito con i pacchetti di questa campagna.",
          "counter": "{{current}} / {{max}}",
          "errorEmpty": "Il messaggio di benvenuto non può essere vuoto.",
          "errorMissingSlot": "Aggiungi {{packs}} nel punto in cui devono comparire i pacchetti della campagna.",
          "versionConflict": "Questo messaggio di benvenuto è stato modificato in un'altra sessione. Ricarica prima di salvare.",
          "translationFailed": "Non è stato possibile tradurre questo messaggio di benvenuto nelle altre lingue, quindi questa versione non è ancora in uso. Modifica il testo e salvalo di nuovo per riprovare."
        },
        "addDialog": {
          "title": "Aggiungi campagna",
          "nameLabel": "Nome campagna",
          "namePlaceholder": "es. Offerta di prova autunnale",
          "validFromLabel": "Inizia",
          "validToLabel": "Termina",
          "allAdsCheckbox": "Tutti i miei annunci Instagram",
          "create": "Crea campagna",
          "nameRequired": "Il nome della campagna è obbligatorio.",
          "dateRangeInvalid": "La data di fine non può essere precedente alla data di inizio."
        },
        "packsCard": {
          "title": "Pacchetti di prova offerti ai contatti della campagna",
          "addPack": "Aggiungi pacchetto",
          "empty": "Ancora nessun pacchetto. Aggiungine uno per offrire una prova ai contatti della campagna.",
          "shopWide": "pacchetto trasversale",
          "linkFromEversports": "link da Eversports",
          "linkPasted": "link incollato",
          "noLinkYet": "il corso non ha ancora un link alla pagina",
          "priceDrift": "prezzo cambiato su Eversports"
        },
        "packPanel": {
          "titleNew": "Nuovo pacchetto",
          "nameLabel": "Nome pacchetto",
          "namePlaceholder": "es. Pacchetto di prova 2+1 20 min",
          "nameRequired": "Il nome del pacchetto è obbligatorio.",
          "priceLabel": "Prezzo",
          "currencyLabel": "Valuta",
          "conditionsLabel": "Condizioni (opzionale)",
          "conditionsPlaceholder": "es. 3 lezioni guidate di bagno di ghiaccio da 20 minuti in 3 mesi",
          "linkedClassSectionTitle": "Corso collegato",
          "pricingOptionsTitle": "Opzioni tariffarie (questo corso, da Eversports)",
          "pricingOptionsEmpty": "Nessuna opzione tariffaria sincronizzata per questo corso al momento.",
          "purchaseLinkLabel": "Link d'acquisto",
          "purchaseLinkPlaceholder": "https://www.eversports.at/e/…",
          "fromEversports": "da Eversports",
          "pasteALink": "Incolla un link",
          "syncClassesAndPricing": "Sincronizza corsi e tariffe",
          "readinessMissingLink": "⚠ Questo corso non ha ancora un link alla pagina.",
          "linkHostWarning": "Questo non sembra un link Eversports. I pacchetti delle campagne vengono solitamente venduti nella tua pagina Prezzi di Eversports.",
          "priceDriftWarning": "Il prezzo del pacchetto è cambiato su Eversports — da verificare (sincronizzato {{synced}})",
          "deleteTitle": "Eliminare il pacchetto?",
          "deleteDescription": "Questa azione non può essere annullata.",
          "delete": "Elimina"
        },
        "classPicker": {
          "linkToClass": "Collega a un corso",
          "shopWidePack": "Pacchetto trasversale — nessun corso specifico",
          "searchPlaceholder": "Cerca tra i tuoi corsi…",
          "loading": "Caricamento dei tuoi corsi…",
          "noMatch": "Nessun corso corrispondente.",
          "addManually": "Non lo trovi? → Aggiungi il corso manualmente",
          "hasPage": "● pagina",
          "noPage": "○ nessuna pagina",
          "changeClass": "Cambia corso",
          "manualNote": "inserito manualmente — non sincronizzato",
          "manual": {
            "nameLabel": "Nome del corso",
            "namePlaceholder": "es. Pure Ice Bath",
            "linkLabel": "Link del corso (pagina corso Eversports)",
            "linkPlaceholder": "https://www.eversports.at/e/…",
            "helper": "Apri il corso su Eversports e incolla l'indirizzo della sua pagina (…/e/… o …/activity/…)."
          }
        },
        "adsCard": {
          "title": "Quali annunci portano qui",
          "radioListed": "Solo gli annunci elencati qui sotto",
          "radioAll": "Tutti i miei annunci Instagram",
          "addAd": "Aggiungi annuncio",
          "adIdLabel": "ID annuncio Meta",
          "adIdHelpAria": "Cos'è l'ID annuncio Meta?",
          "adIdTooltipWhy": "È così che riconosciamo le persone che arrivano da questo annuncio, in modo che ricevano il messaggio di benvenuto di questa campagna.",
          "adIdTooltipWhere": "Copia l'ID annuncio dalla colonna «ID annuncio» in Meta Ads Manager — oppure incolla direttamente il link di Ads Manager dell'annuncio in questo campo.",
          "adIdPlaceholder": "es. 120212345678901234",
          "labelOptional": "Etichetta (opzionale)",
          "labelPlaceholder": "es. Annuncio di prova estivo",
          "empty": "Ancora nessun annuncio elencato.",
          "delete": "Rimuovi annuncio",
          "edit": "Modifica annuncio",
          "formatError": "Inserisci il numero dell'annuncio oppure incolla il link di Meta Ads Manager dell'annuncio.",
          "campaignLinkError": "Questo link punta a una campagna, non a un singolo annuncio. Apri l'annuncio stesso in Ads Manager e incolla quel link.",
          "adsetLinkError": "Questo link punta a un gruppo di annunci, non a un singolo annuncio. Apri l'annuncio stesso in Ads Manager e incolla quel link.",
          "multipleAdsError": "Questo link contiene più di un annuncio. Aggiungi un annuncio alla volta.",
          "duplicateError": "Questo ID annuncio è già elencato.",
          "conflictError": "Già utilizzato da \"{{name}}\" (fino al {{date}}).",
          "conflictErrorOpenEnded": "Questo annuncio è riservato da «{{name}}» senza data di fine. Imposta una data di fine per la campagna che lo riserva.",
          "wildcardConflictErrorOpenEnded": "Tutti gli annunci sono riservati da «{{name}}» senza data di fine. Imposta una data di fine per la campagna che li riserva.",
          "wildcardConflictError": "\"{{name}}\" rivendica già tutti gli annunci in un periodo che si sovrappone (fino al {{date}}).",
          "helperTitle": "Come trovo l'ID annuncio Meta?",
          "helperStep1": "Apri Gestione annunci Meta → scheda Annunci.",
          "helperStep2": "Aggiungi la colonna \"ID annuncio\" (Colonne → Personalizza) — oppure apri l'annuncio e incolla qui il suo indirizzo completo; troveremo il numero dopo \"selected_ad_ids=\".",
          "helperStep3": "Incolla qui il numero — oppure incolla il link di Ads Manager dell'annuncio e troveremo noi il numero.",
          "learnMore": "Scopri di più",
          "notSureHint": "Non sei sicuro? Per ora scegli \"Tutti i miei annunci Instagram\" — potrai restringere la scelta più avanti."
        }
      },
      "faq": {
        "saving": "Salvataggio…",
        "saved": "Salvato",
        "addFaq": "Aggiungi FAQ",
        "readOnly": "Sola lettura",
        "questionPlaceholder": "Domanda",
        "answerPlaceholder": "Risposta",
        "deleteTitle": "Eliminare le FAQ?",
        "deleteDescription": "Non sarà possibile annullare questa operazione.",
        "delete": "Elimina",
        "empty": "Ancora nessuna FAQ. Aggiungi la prima qui sopra.",
        "toastAdded": "FAQ aggiunta.",
        "toastAddFailed": "IMPOSSIBILE AGGIUNGERE",
        "toastUpdated": "FAQ aggiornate.",
        "toastUpdateFailed": "Impossibile aggiornare",
        "toastDeleted": "FAQ eliminata.",
        "toastDeleteFailed": "Eliminazione fallita."
      },
      "general": {
        "openingHours": "Orari di apertura",
        "closed": "Chiuso",
        "location": "Location",
        "description": "Descrizione",
        "descriptionPlaceholder": "Breve panoramica per clienti e IA—offerta, atmosfera e dettagli pratici come il parcheggio.",
        "address": "Indirizzo",
        "addressPlaceholder": "es. Via Roma 42, 20121 Milano",
        "addressInvalid": "Inserisci un indirizzo con lettere, un numero e uno spazio o una virgola.",
        "timezone": "Fuso orario dello studio",
        "timezonePlaceholder": "es. Europe/Rome",
        "timezoneHelper": "Usato per gli orari e le azioni sensibili al tempo di questo studio.",
        "timezoneInvalid": "Inserisci un fuso orario IANA valido, ad esempio Europe/Rome.",
        "hoursRequired": "Imposta un orario di apertura e di chiusura per {{day}}, oppure segna il giorno come chiuso.",
        "hoursOutOfOrder": "L'orario di chiusura per {{day}} deve essere successivo all'orario di apertura.",
        "mapsLink": "Link Google Maps",
        "mapsLinkPlaceholder": "https://maps.google.com/…",
        "mapsLinkInvalid": "Inserisci un link di Google Maps.",
        "directions": "Indicazioni",
        "directionsPlaceholder": "Come raggiungerci—ingresso, piano, mezzi, parcheggio o altri consigli per l’arrivo.",
        "contacts": "Contatti",
        "phone": "Telefono principale",
        "phonePlaceholder": "+39 02 1234567",
        "phoneInvalid": "Inserisci un numero di telefono con almeno 6 cifre. Solo cifre e punteggiatura standard.",
        "email": "E-mail principale",
        "emailPlaceholder": "ciao@iltuostudio.it",
        "emailInvalid": "Inserisci un indirizzo e-mail valido.",
        "website": "Sito web",
        "websitePlaceholder": "iltuostudio.it",
        "facilities": "certificate ISO",
        "facilityPlaceholder": "Aggiungi struttura",
        "add": "Aggiungi",
        "firstVisit": "Prima visita",
        "firstVisitLinks": {
          "trialRegistrationLabel": "Link registrazione prova (Scenario 1)",
          "trialRegistrationPlaceholder": "iltuostudio.it/registrazione-prova",
          "trialRegistrationHelper": "Usato quando il cliente non ha ancora un account sulla piattaforma di prenotazione.",
          "studioLabel": "Pagina Eversports dello studio (Scenario 2)",
          "studioPlaceholder": "www.eversports.com/s/il-tuo-studio",
          "studioHelper": "Usato quando il cliente ha un account Eversports ma è nuovo nel tuo studio. Per info generali preferisci Overview sotto.",
          "overviewLabel": "Pagina Panoramica",
          "overviewPlaceholder": "www.eversports.com/s/il-tuo-studio",
          "overviewHelper": "Sezione Panoramica pubblica (chi siamo, indirizzo, servizi). Per domande generali sullo studio.",
          "classesLabel": "Calendario corsi",
          "classesPlaceholder": "www.eversports.com/scl/il-tuo-studio",
          "classesHelper": "Calendario settimanale pubblico. Quando i clienti chiedono cosa c'è o come prenotare.",
          "pricesLabel": "Pagina Prezzi",
          "pricesPlaceholder": "www.eversports.com/sp/il-tuo-studio",
          "pricesHelper": "Catalogo pubblico prezzi / prodotti. Per abbonamenti e prezzi dei prodotti.",
          "urlInvalid": "Aggiungi l’indirizzo del sito, per esempio rowinc.studio."
        },
        "firstVisitPlaceholder": "Cosa devono sapere i nuovi clienti prima della prima visita—arrivo, cosa portare, check-in e regole dello studio.",
        "saveChanges": "Salva Modifiche",
        "toastSaved": "Modifiche salvate.",
        "toastSaveFailed": "Salvataggio non riuscito ",
        "weekday": {
          "monday": "Lunedì",
          "tuesday": "Martedì",
          "wednesday": "Mercoledì",
          "thursday": "Giovedì",
          "friday": "Venerdì",
          "saturday": "Sabato",
          "sunday": "Domenica"
        }
      },
      "generalPublic": {
        "heading": "Info pubbliche dello studio",
        "syncLabel": "Sincronizza Generale",
        "syncCaption": "La sincronizzazione di Generale aggiorna insieme la descrizione pubblica, i servizi, Instagram e la valutazione.",
        "previewCaption": "Dati di anteprima — non sono dati studio realmente sincronizzati",
        "empty": "Non ancora sincronizzato. Fai clic su \"Sincronizza Generale\" per un'anteprima delle info pubbliche di esempio.",
        "aboutHeading": "Chi siamo",
        "amenitiesHeading": "Servizi",
        "amenityOffered": "Disponibile",
        "amenityNotOffered": "Non disponibile",
        "amenityUnknown": "Non ancora sincronizzato",
        "ratingLabel": "{{value}} ({{count}} recensioni)"
      },
      "policies": {
        "toastSaved": "Sostituzione politica salvata.",
        "toastSaveFailed": "Salvataggio non riuscito ",
        "toastAdded": "Policy aggiunta.",
        "toastAddFailed": "Impossibile aggiungere la policy.",
        "toastUpdated": "Policy aggiornata.",
        "toastUpdateFailed": "Impossibile aggiornare la policy.",
        "toastDeleted": "Policy eliminata.",
        "toastDeleteFailed": "Impossibile eliminare la policy.",
        "syncedFrom": "Sincronizzato da {{source}}",
        "bookingPlatformFallback": "Piattaforma di Booking",
        "manualEntriesTitle": "Policy personalizzate",
        "addPolicy": "Aggiungi policy",
        "policyTitlePlaceholder": "Titolo della policy",
        "policyContentPlaceholder": "Inserisci i dettagli della policy…",
        "manualEntriesEmpty": "Nessuna policy personalizzata.",
        "deleteTitle": "Eliminare la policy?",
        "deleteDescription": "Questa voce di policy verrà eliminata.",
        "delete": "Elimina",
        "ownerOverride": "Sovrascrittura del proprietario",
        "overridePlaceholder": "Inserisci il testo della tua politica per sovrascrivere la versione sincronizzata...",
        "saveOverride": "Salva sovrascrittura",
        "overrideActive": "Sovrascrittura proprietario (attiva)",
        "refundIfCancelledAtLeast": "Rimborso se disdetto almeno",
        "beforeClassStart": "prima dell’inizio del corso",
        "hoursBeforeClassStart": "ore prima dell’inizio del corso",
        "hoursPreset": "{{count}} ore",
        "hoursCustom": "Personalizzato…",
        "toastInvalidHours": "Inserisci un numero intero di ore tra 1 e 168.",
        "customHoursAria": "Ore personalizzate",
        "hoursInfoAria": "Altre informazioni su questa regola",
        "hoursInfoTitle": "Su questo numero",
        "hoursInfoCredit": "Credito corso o pass restituito — non un rimborso bancario.",
        "hoursInfoMove": "Le stesse ore se chiedono di spostare quel corso.",
        "hoursInfoNumberBeatsNotes": "Copilot segue questo numero, non le note sotto.",
        "hoursPreview": "I clienti che disdicono {{hours}} ore o più prima dell’inizio del corso possono ricevere un credito corso o il pass. Più tardi: possono ancora disdire o spostare, senza credito.",
        "additionalNotes": "Note aggiuntive sulla disdetta (facoltativo)",
        "additionalNotesHint": "Eccezioni, malattia, preavviso abbonamento — Copilot può spiegarle. Non modificano le ore sopra.",
        "additionalNotesPlaceholder": "Inserisci note di policy extra…",
        "saveAdditionalNotes": "Salva",
        "additionalNotesActive": "Note aggiuntive",
        "empty": "Nessuna sezione policy ancora. Collega una piattaforma di prenotazione per sincronizzare il testo delle policy.",
        "syncCancellationPolicy": "Sincronizza policy di cancellazione",
        "syncRefundPolicy": "Sincronizza policy di rimborso",
        "cancellationPolicyEmpty": "Non ancora pubblicata pubblicamente — nulla di inventato. Clicca su \"Sincronizza policy di cancellazione\" per controllare di nuovo.",
        "refundPolicyEmpty": "Non ancora pubblicata pubblicamente — nulla di inventato. Clicca su \"Sincronizza policy di rimborso\" per controllare di nuovo.",
        "refundPolicyPreviewLine": "Dati di anteprima — non è testo di policy realmente importato: \"Rimborso completo fino a 24 ore prima dell’inizio del corso; credito corso dopo.\""
      },
      "prices": {
        "syncCaption": "La sincronizzazione dei prezzi aggiorna questa scheda e le opzioni di prezzo di ogni corso insieme.",
        "previewCaption": "Dati di anteprima — non sono i prezzi Eversports live",
        "membershipsHeading": "Abbonamenti",
        "membershipsEmpty": "Non ancora sincronizzato. Clicca su \"Sincronizza prezzi\" per vedere un'anteprima di abbonamenti di esempio.",
        "productsHeading": "Prodotti",
        "productsEmpty": "Non ancora sincronizzato. Clicca su \"Sincronizza prezzi\" per vedere un'anteprima di prodotti di esempio.",
        "minRuntime_one": "{{count}} mese minimo",
        "minRuntime_other": "{{count}} mesi minimo"
      },
      "team": {
        "syncCaption": "La sincronizzazione del team aggiorna questa scheda con l'elenco degli istruttori dalla tua pagina Eversports pubblica.",
        "previewCaption": "Dati di anteprima — non un elenco reale di istruttori",
        "heading": "Istruttori",
        "empty": "Non ancora sincronizzato. Clicca su \"Sincronizza team\" per vedere un'anteprima di istruttori di esempio.",
        "viewSchedule": "Vedi il calendario"
      },
      "users": {
        "selectStudio": "Seleziona uno studio per gestire gli utenti.",
        "peopleWithAccessLead": "Persone con accesso a",
        "peopleWithAccessTrail": ".",
        "thisStudio": "questo studio",
        "addMember": "Aggiungi membro",
        "inviteTitle": "Invita un membro del team",
        "email": "Email",
        "managerInviteShort": "I manager possono invitare solo il personale.",
        "sendInvitation": "Invia un invito",
        "revokeHintAddMember": "Puoi inviare un nuovo invito più tardi da «Aggiungi membro» se cambi idea.",
        "emptyTeam": "Nessun membro del team o invito in sospeso."
      },
      "sidePanel": {
        "title": "Aggiungi studio",
        "studioName": "Nome studio",
        "namePlaceholder": "Inserisci il nome dello studio",
        "nameRequired": "Il nome dello studio è obbligatorio.",
        "nameTooShort": "Il nome dello studio deve contenere almeno 2 caratteri.",
        "nameTooLong": "Il nome dello studio può contenere al massimo 60 caratteri.",
        "nameAlreadyExists": "Questo nome dello studio esiste già.",
        "nameArchivedConflict": "Questo nome corrisponde a uno studio archiviato. Ripristina o rinomina prima lo studio archiviato.",
        "studioLimitReached": "Massimo 5 studi attivi. Archivia uno studio prima di crearne un altro.",
        "description": "Descrizione",
        "descriptionPlaceholder": "Inserisci la descrizione dello studio",
        "descriptionTooLong": "La descrizione può contenere al massimo 200 caratteri.",
        "descriptionCharCount": "{{current}}/{{max}}",
        "teamMembers": "Membri del team",
        "teamHint": "Invita persone dopo la creazione dello studio oppure aggiungi nome ed email qui sotto per invitare automaticamente.",
        "memberNamePlaceholder": "Nome completo",
        "memberNameRequired": "Il nome è obbligatorio.",
        "memberNameAria": "Nome dell’invitato",
        "memberEmailAria": "Email dell’invitato",
        "emailPlaceholder": "email@esempio.com",
        "emailRequired": "L'email è obbligatoria.",
        "emailInvalid": "Inserisci un indirizzo email valido.",
        "emailDuplicate": "Questa email è già nell'elenco.",
        "addMemberButtonAria": "Aggiungi membro del team all’elenco",
        "editMemberAria": "Modifica membro del team",
        "saveMemberEdit": "Salva membro",
        "finishEditingFirst": "Salva o annulla le modifiche prima di creare lo studio.",
        "removeAria": "Rimuovi",
        "cancel": "Annulla",
        "create": "Crea studio",
        "toastInvalidEmail": "Inserisci un indirizzo email valido.",
        "toastDuplicateEmail": "Questa email è già nell'elenco.",
        "toastCreateFailed": "Impossibile creare lo studio.",
        "toastInviteFailed": "Impossibile inviare l'invito a {{email}}.",
        "toastCreated": "Studio creato.",
        "toastGrantFailedExisting": "Impossibile concedere l'accesso a {{email}} per questo studio.",
        "toastGrantAlreadyMemberExisting": "{{email}} è già membro di questo nuovo studio."
      },
      "trace": {
        "panelTitle": "Traccia agent vision",
        "closeAria": "Chiudi",
        "enterFullscreenAria": "Espandi a schermo intero",
        "exitFullscreenAria": "Esci da schermo intero",
        "backToClasses": "Torna alle lezioni",
        "pageTitle": "Traccia agent vision",
        "pageSubtitle": "Scegli un'esecuzione recente dall'elenco (audit ClickHouse) o incolla un ID esecuzione. S3 è necessario per screenshot e download degli artefatti.",
        "selectStudioForTraces": "Seleziona uno studio per caricare le tracce.",
        "recentRuns": "Esecuzioni recenti dell'agent",
        "window": "Finestra",
        "daysOption": "{{count}} giorni",
        "refresh": "Aggiorna",
        "clickHouseNoList": "Nessuna esecuzione dell'agente in questo periodo. L'audit ClickHouse non è configurato: questo elenco proviene dal log di audit Postgres locale. Usa «ID esecuzione» sotto se hai un UUID.",
        "loadingRuns": "Caricamento esecuzioni…",
        "lastActivity": "Ultima attività",
        "platform": "Piattaforma",
        "lastEvent": "Ultimo evento",
        "events": "Eventi",
        "estimatedLlmCostColumn": "Costo LLM stimato",
        "runsListTotalEstimatedLlmCost": "Totale esecuzioni mostrate (LLM stimato): {{amount}}",
        "runsListCostDisclaimer": "Importi stimati nell’app dall’uso dei token (euristiche listino), non fatture.",
        "runIdLabel": "ID esecuzione (facoltativo)",
        "runIdSrOnly": "ID esecuzione agent",
        "runIdPlaceholder": "Incolla l'UUID se non è nell'elenco sopra",
        "loadTrace": "Carica traccia",
        "loadError": "Impossibile caricare la traccia.",
        "syncComplete": "Sincronizzazione completata",
        "syncFailed": "Sincronizzazione non riuscita",
        "runLoaded": "Esecuzione caricata",
        "linkPlaywrightTrace": "Traccia Playwright",
        "linkRecording": "Registrazione",
        "linkHar": "HAR",
        "linkLlmDecisions": "Decisioni LLM",
        "latestStepAlt": "Ultimo passo",
        "classesSynced": "{{count}} lezioni sincronizzate",
        "percentComplete": "100 %",
        "llmTotalLabel": "Totale LLM:",
        "llmCallsCount": "({{count}} chiamate)",
        "failureHeading": "Screenshot dell'errore",
        "failureAlt": "Errore",
        "s3NotConfigured": "Le tracce agent su S3 non sono configurate su questo server; screenshot e download non disponibili.",
        "durationMs": "{{n}} ms",
        "durationSeconds": "{{n}} s",
        "runDurationSuffix": " · {{n}} s",
        "tokensSummary": "{{input}} in / {{output}} out ({{total}} token)",
        "orchestratorTraceHeading": "Traccia orchestratore chat",
        "intent": "Intento",
        "confidence": "Confidenza",
        "decisionOrigin": "Decisione",
        "groundingVerdict": "Grounding",
        "escalationReason": "Escalation",
        "toolsCalled": "Tool",
        "toolOutcome": "Esito del tool",
        "ragChunks": "RAG",
        "decisionSteps": "Passi decisionali",
        "llmTemperature": "temp {{value}}",
        "llmMaxTokens": "max {{value}} token",
        "expandDetails": "Dettagli",
        "collapseDetails": "Nascondi",
        "executionRoute": "Percorso",
        "interactionMode": "Modalità",
        "subFlow": "Sotto-flusso",
        "method": "Metodo",
        "selfHealed": "Auto-riparato",
        "systemPrompt": "Sistema",
        "userPrompt": "Utente",
        "llmResponse": "Risposta",
        "llmPromptKey": "Prompt",
        "llmPromptSummary": "Struttura",
        "llmReasoning": "Ragionamento",
        "promptKind": "Tipo",
        "workflowLiveBadge": "Live",
        "workflowReplayBadge": "Replay",
        "workflowTopologyTitle": "Topologia del workflow",
        "workflowEventsCount": "{{count}} eventi live",
        "cascadeOf": "Cascata dell’errore radice {{rootCauseId}}",
        "technicalDetails": "Dettagli tecnici",
        "openConversation": "Apri la conversazione",
        "privacyHiddenContent": "(contenuto nascosto per privacy)",
        "tier": {
          "decisionLabel": "Decisione del livello",
          "name": {
            "json_feed": "Feed JSON",
            "dom_text_early": "Testo DOM (precoce)",
            "dom_script": "Script DOM",
            "cli_playwright": "CLI Playwright",
            "mcp_text": "Testo MCP",
            "vision_agent": "Agente vision"
          },
          "outcome": {
            "success": "Successo",
            "fail": "Fallito",
            "skip": "Saltato"
          },
          "reason": {
            "skip_anonymous_or_non_schedule": "Saltato (anonimo / fuori calendario)",
            "skip_dom_not_applicable": "Saltato (DOM non applicabile)",
            "disabled_by_config": "Disabilitato dalla configurazione",
            "consecutive_failures": "Errori consecutivi",
            "llm_last_resort_enabled": "LLM come ultima risorsa attivo",
            "range_mismatch": "Intervallo date non coerente",
            "empty_feed": "Feed vuoto",
            "tier_timeout": "Timeout del livello",
            "tier_error": "Errore del livello",
            "selector_not_found": "Selettore non trovato",
            "initial_navigation_failed": "Navigazione iniziale fallita",
            "auth_retry_limit": "Limite di tentativi di autenticazione raggiunto",
            "reauth_failed": "Riautenticazione fallita",
            "no_meaningful_result": "Nessun risultato utile"
          }
        }
      },
      "classes": {
        "weekdayMon": "lun",
        "weekdayTue": "mar",
        "weekdayWed": "mer",
        "weekdayThu": "gio",
        "weekdayFri": "ven",
        "weekdaySat": "sab",
        "weekdaySun": "dom",
        "viewList": "Elenco",
        "viewCalendar": "Calendario",
        "syncComplete": "Sincronizzazione completata",
        "syncFailed": "Sincronizzazione non riuscita",
        "syncing": "Sincronizzazione…",
        "viewTrace": "Vedi traccia",
        "latestStepAlt": "Ultimo passo",
        "agentScreenshots": "Screenshot dell'agent ({{count}})",
        "stepLabel": "Passo {{n}}",
        "tableClass": "Lezione",
        "tableInstructor": "Istruttore",
        "tableTime": "Orario",
        "tableDuration": "Durata",
        "tableLevel": "Livello",
        "tableSpots": "Posti nella prossima lezione",
        "minutes": "{{n}} min",
        "spotsLeft": "{{n}} liberi",
        "full": "Pieno",
        "emptyList": "Nessuna lezione sincronizzata ancora. Collega una piattaforma di prenotazione ed esegui una sincronizzazione.",
        "detailStudio": "Studio",
        "detailLocation": "Sede",
        "detailTrainer": "Istruttore",
        "detailTime": "Orario",
        "detailCapacity": "Capienza",
        "detailDuration": "Durata",
        "about": "Informazioni",
        "descriptionEmpty": "Nessuna descrizione del corso sincronizzata ancora.",
        "pricingOptions": "Opzioni prenotabili di questa lezione",
        "pricingOptionsEmpty": "Opzioni di prezzo non ancora disponibili. Copilot non inventa prezzi.",
        "links": "Link",
        "classPageLink": "Apri pagina del corso",
        "bookingLink": "Apri link di prenotazione",
        "bookSlot": "Prenota",
        "clients": "Clienti ({{count}})",
        "bookingConfirmed": "Confermata",
        "bookingWaitlisted": "In lista d'attesa",
        "bookingCancelled": "Annullata",
        "bookingCheckedIn": "Check-in effettuato",
        "upcomingSchedule": "Prossimi appuntamenti",
        "noUpcomingSessions": "Nessuna sessione in questo periodo.",
        "showNextMonth": "Mostra mese successivo",
        "showNextMonthAria": "Mostra mese successivo",
        "loading": "Caricamento in corso…",
        "toastSyncComplete": "Sincronizzazione completata con successo.",
        "toastSyncFailed": "Sincronizzazione non riuscita.",
        "toastSyncBookingPlatformNotConfigured": "Collega una piattaforma di prenotazioni (Eversports, Mindbody o Bsport) prima di sincronizzare.",
        "syncLogInit": "Avvio sincronizzazione per {{start}} → {{end}}…",
        "syncLogStarted": "Job di sincronizzazione avviato sul server",
        "syncLogScreenshots": "Caricati {{count}} screenshot dell'agent",
        "syncLogCompleted": "Sincronizzazione completata",
        "syncLogFailedMsg": "Sincronizzazione non riuscita",
        "syncStartError": "Impossibile avviare la sincronizzazione"
      }
    }
  },
  "studioDataFilter": {
    "filter": "Filtro",
    "clearAll": "Elimina tutto",
    "panelTitle": "Filtro",
    "panelDescription": "Narrow the studio list by integrations, booking source, and location.",
    "closeSheetAria": "Chiudi",
    "sheetAriaLabel": "Filter studios",
    "channelConnection": "{{channel}} — connection",
    "sectionBookingSource": "Booking source",
    "sectionLocation": "Location (city, country)",
    "channelInstagram": "Instagram",
    "channelWhatsapp": "WhatsApp",
    "channelBooking": "Prenota",
    "tagChannelStatus": "{{channel}}: {{status}}",
    "tagSource": "Source: {{source}}",
    "connectionStatus": {
      "connected": "Connected",
      "error": "Error",
      "not_connected": "Not connected"
    },
    "bookingSource": {
      "eversports": "Eversports",
      "mindbody": "Mindbody",
      "bsport": "Bsport",
      "none": "None",
      "other": "Altro"
    }
  },
  "team": {
    "selectStudioHint": "Select a studio in the header switcher to view the team list, remove members, and use Invite again for pending invites.",
    "aggregateListHint": "Membri del team e inviti in sospeso sono elencati per ogni studio a cui hai accesso. Rimuovi e reinvia si riferiscono allo studio indicato in ogni riga.",
    "inviteMember": "Invite Team Member",
    "studiosMultiLabel": "Studios (select one or more)",
    "studioSingleLabel": "Studio",
    "noStudiosForInvite": "No studios are available for invitations with your account.",
    "includeStudioAria": "Include {{name}}",
    "emailAddress": "Email address",
    "inviteNamePlaceholder": "Inserisci il nome",
    "emailPlaceholder": "team@studio.com",
    "role": "Role",
    "roleManager": "Manager",
    "roleStaff": "Staff",
    "managerInviteHint": "Managers can invite Staff only (per studio access you manage).",
    "accessPreview": "They will get access to {{studios}} as {{role}}.",
    "roleOwner": "Owner",
    "sendInvitation": "Send Invitation",
    "colName": "Name",
    "pendingInviteNoName": "—",
    "pendingInviteNameSr": "Invito in sospeso per {{email}}",
    "emailInvalid": "Inserisci un indirizzo email valido.",
    "colStudio": "Studio",
    "colEmail": "Email",
    "colRole": "Role",
    "colStatus": "Stato",
    "colActions": "Actions",
    "statusActive": "Active",
    "statusPending": "Pending",
    "ownerCannotRemove": "Studio owners cannot be removed here",
    "inviteAgain": "Invite again",
    "inviteToOtherStudios": "Invita ad altri studi",
    "editAccess": "Modifica accesso",
    "editAccessLoadingStudios": "Caricamento degli studi in cui questo membro ha accesso…",
    "editAccessPerStudioHint": "Scegli un ruolo per ogni studio. Sono elencati solo gli studi che puoi gestire.",
    "editAccessNothingChanged": "Nessuna modifica da salvare.",
    "editAccessStudioRoleAria": "{{studio}} — ruolo",
    "editAccessMemberDetail": "{{name}} · {{email}}",
    "removeMemberMultiHint": "Scegli ogni studio da cui vuoi rimuovere questa persona. Gli studi non selezionati mantengono l'accesso.",
    "removeMemberLoadingScope": "Verifica degli studi…",
    "removeMemberStudioToggleAria": "Rimuovi da {{name}}",
    "removeMemberPickOneStudio": "Seleziona almeno uno studio.",
    "toastMemberRemovedMulti": "Rimosso da {{count}} studi.",
    "toastRemovePartialFail": "Impossibile rimuovere da: {{studios}}. Riprova per questi studi.",
    "resendInvitation": "Reinvia invito",
    "editPendingInviteAria": "Modifica l'invito in sospeso per {{email}}",
    "editPendingInviteTitle": "Modifica invito in sospeso",
    "editPendingInviteSave": "Salva modifiche",
    "toastInviteUpdated": "Invito aggiornato.",
    "toastAccessUpdated": "Accesso del membro aggiornato.",
    "toastEditAccessPartialFail": "Impossibile aggiornare l'accesso per: {{studios}}. Riprova per questi studi.",
    "toastInviteUpdatePartial": "Vecchio invito revocato, ma il reinvio non è riuscito. Usa «Aggiungi membro» per invitare di nuovo.",
    "removeMemberAria": "Remove {{name}} from studio",
    "revokeInviteAria": "Revoke invitation",
    "removeMemberTitle": "Remove team member",
    "removeMemberBody": "Are you sure you want to remove this person from the studio?",
    "removeMemberDetail": "{{name}} ({{email}}) will lose access to this studio immediately.",
    "removeMemberDetailStudio": "{{name}} ({{email}}) perderà immediatamente l’accesso a {{studio}}.",
    "dangerIrreversible": "This action is irreversible from here. Their OktoGo account is not deleted; you can invite them again later if needed.",
    "removeAnyway": "Remove anyway",
    "revokeTitle": "Revoke invitation",
    "revokeBody": "The pending invite to {{email}} will be cancelled. They will not be able to join with the current link.",
    "revokeHint": "You can send a new invitation later from Invite Team Member if you change your mind.",
    "revoke": "Revoke",
    "toastInviteSent": "Invitation sent.",
    "toastInviteFailed": "Failed to send invitation.",
    "toastAlreadyMember": "{{email}} è già membro di questo studio. Apri l'elenco del team qui sotto per gestire il ruolo.",
    "toastAlreadyMemberMulti": "{{email}} è già membro di uno degli studi selezionati. Deselezionalo e riprova.",
    "addMemberSearchPlaceholder": "Aggiungi per nome o email",
    "addMemberSearchHint": "Scegli una persona dai tuoi studi o digita una nuova email per invitarla.",
    "candidateSearching": "Ricerca in corso…",
    "candidateNoMatches": "Nessun membro corrispondente nei tuoi studi.",
    "candidateNoMatchHelp": "Non riconosciamo ancora questa email — invieremo un invito.",
    "candidateAlreadyMemberBadge": "Già membro",
    "candidateChange": "Cambia",
    "candidateAlreadyInLabel": "Già in: {{studios}}",
    "refineSearch": "Affina la ricerca.",
    "candidateAlreadyMemberHere": "{{name}} è già membro di questo studio.",
    "grantAccessTitle": "Concedi accesso",
    "grantAccessButton": "Concedi accesso",
    "grantAccessNotice": "{{name}} vedrà questo accesso alla prossima apertura di OktoGo.",
    "toastGrantSuccess": "Accesso concesso a {{name}}.",
    "toastGrantFailed": "Impossibile concedere l'accesso.",
    "toastMemberRemoved": "Member removed from this studio.",
    "toastRemoveFailed": "Failed to remove member.",
    "toastResent": "Invitation sent again.",
    "toastResendFailed": "Failed to resend.",
    "toastResendRateLimited": "L'invito è appena stato reinviato. Riprova tra qualche minuto.",
    "toastRevoked": "Invitation revoked.",
    "toastRevokeFailed": "Failed to revoke.",
    "candidateSelectBeforeInvite": "{{email}} appartiene già a un utente esistente. Seleziona quell'utente dall'elenco per concedere l'accesso."
  },
  "connections": {
    "addChannel": "Add Channel",
    "addBookingPlatform": "Aggiungi piattaforma di prenotazione",
    "mockModeBanner": "Modalità simulazione — i canali sono simulati, nessuna connessione Meta o piattaforma di prenotazione reale.",
    "mockReconnectHint": "In modalità simulazione: usa Riconnetti per aggiornare lo stato WhatsApp simulato.",
    "errors": {
      "connectionIssue": "Problema di connessione",
      "activationRequired": "Attivazione WhatsApp richiesta — inserisci il PIN a 6 cifre nelle Impostazioni"
    },
    "colChannel": "Channel",
    "colIdentifier": "Identifier",
    "colAppliesTo": "Si applica a",
    "colStatus": "Stato",
    "colActions": "Actions",
    "statusConnected": "Connected",
    "statusError": "Error",
    "statusSkipped": "Skipped",
    "statusNotConnected": "Not connected",
    "connectedSince": "Connected since {{date}}",
    "connectedSinceLabel": "Connesso dal",
    "lastSynced": "Last synced: {{time}}",
    "configure2fa": "Configure 2FA",
    "reconnect": "Reconnect",
    "connect": "Connettiti",
    "emptyChannels": "No channels configured. Add one to get started.",
    "modalAddTitle": "Add Channel",
    "channelType": "Channel Type",
    "addChannelTenantScopeHint": "I canali di messaggistica si applicano a tutti gli studi del tuo account. Non stai assegnando un canale a un singolo studio.",
    "addChannelSubmit": "Add Channel",
    "bookingReconnectTitle": "Reconnect Booking Platform",
    "bookingConnectTitle": "Connect Booking Platform",
    "bookingTenantScopeHint": "Le credenziali della piattaforma di prenotazione si applicano a tutti gli studi del tuo account. Non stai limitando questa integrazione a un solo studio.",
    "twoFaTenantScopeHint": "L'autenticazione a due fattori per le prenotazioni vale a livello di account per Eversports e riguarda tutti gli studi che usano questa connessione.",
    "platformLabel": "Platform",
    "bookingPlatformLabel": "Booking Platform",
    "selectPlatformPlaceholder": "Select your platform",
    "usernameEmail": "Username / Email",
    "usernamePlaceholder": "you@studio.com",
    "password": "Password",
    "passwordPlaceholder": "••••••••",
    "updateCredentials": "Update credentials",
    "twoFaModalTitle": "Configure Eversports 2FA",
    "twoFaMethod": "Method",
    "twoFaTotp": "TOTP (Authenticator app)",
    "twoFaEmail": "Email code",
    "twoFaSms": "SMS code",
    "twoFaSecretLabel": "Secret / code",
    "twoFaContactLabel": "Phone or email",
    "twoFaSecretPlaceholder": "Paste TOTP secret or code",
    "twoFaContactPlaceholder": "Phone number or email",
    "twoFaCodeLabel": "Chiave di autenticazione",
    "twoFaCodePlaceholder": "Incolla la chiave segreta TOTP dell'autenticatore",
    "twoFaCodeHint": "Trova questa chiave nella configurazione della tua app di autenticazione (es. Google Authenticator, Authy). Il codice verrà generato automaticamente.",
    "save": "Salva",
    "toastStartFlowFailed": "Could not start connection flow.",
    "toastReconnectStarted": "Reconnect flow started.",
    "toastReconnectFailed": "Reconnect failed.",
    "toastDisconnected": "Disconnected.",
    "toastDisconnectFailed": "Disconnect failed.",
    "toastBookingCredentialsUpdated": "Booking platform credentials updated.",
    "toastBookingConnected": "Booking platform connected.",
    "toast2faConfigured": "2FA configured.",
    "errorUserPassRequired": "Username and password are required.",
    "errorSelectPlatform": "Please select a booking platform.",
    "errorInvalidCredentials": "Invalid credentials or platform unavailable. Please retry.",
    "errorGenericRetry": "Something went wrong. Please retry.",
    "error2faSecretRequired": "Secret or code is required.",
    "error2faCodeRequired": "La chiave di autenticazione è obbligatoria per Eversports.",
    "errorUpdateFailed": "Update failed.",
    "errorConnectFailed": "Connect failed.",
    "errorConfigure2faFailed": "Failed to configure 2FA.",
    "errorNoStudioForApi": "Nessuno studio disponibile per questo account. Aggiungi uno studio prima di gestire le connessioni.",
    "channelInstagram": "Instagram",
    "channelWhatsapp": "WhatsApp",
    "channelBooking": "Piattaforma di Booking",
    "profile": {
      "viewProfile": "Visualizza profilo",
      "whatsappTitle": "Connessione WhatsApp",
      "instagramTitle": "Connessione Instagram",
      "sectionAssets": "Account e risorse",
      "sectionTemplates": "Modelli di messaggio",
      "templatesSubtitle": "I modelli devono essere approvati da Meta prima dell'uso fuori dalla finestra di 24 ore.",
      "expand": "Espandi pannello",
      "collapse": "Comprimi pannello",
      "refresh": "Aggiorna",
      "disconnect": "Disconnetti",
      "disconnectTitle": "Disconnettere il canale?",
      "disconnectBody": "Rimuove la connessione del canale per questo studio. Puoi riconnetterti in seguito da Impostazioni.",
      "templatesPickerHint": "I modelli approvati possono essere selezionati in Chat quando rispondi su WhatsApp.",
      "loading": "Caricamento dettagli connessione…",
      "pageName": "Pagina Facebook",
      "pageId": "ID pagina",
      "emailTitle": "Connessione e-mail",
      "providerLabel": "Provider",
      "providerGoogle": "Google",
      "providerMicrosoft": "Microsoft",
      "grantHealthWarning": "La connessione e-mail è scaduta. Riconnetti per inviare e ricevere messaggi.",
      "errorLoadEmail": "Impossibile caricare i dettagli della connessione e-mail."
    },
    "whatsapp": {
      "templates": {
        "create": "Crea modello di messaggio",
        "editTitle": "Visualizza e modifica modello",
        "editSubtitleEditable": "Aggiorna categoria o testo del messaggio, poi salva. Meta revisionerà automaticamente il modello.",
        "editSubtitleReadOnly": "Questo modello è in attesa o approvato e non può essere modificato qui.",
        "saveChanges": "Salva modifiche",
        "saveSuccess": "Modello salvato e inviato a Meta per revisione",
        "saveFailed": "Impossibile salvare le modifiche al modello",
        "nameLocked": "Il nome del modello non può essere modificato dopo la creazione",
        "submit": "Invia per approvazione",
        "testSend": "Invio di prova",
        "preview": "Anteprima",
        "reviewPresets": "Modelli OktoGo consigliati",
        "testSendDialogTitle": "Invia messaggio di prova",
        "testSendSuccess": "Messaggio di prova in coda",
        "testSendFailed": "Invio di prova non riuscito",
        "createSuccess": "Modello inviato a Meta",
        "createFailed": "Impossibile creare il modello",
        "submitFailed": "Impossibile inviare il modello per approvazione",
        "emptyProfile": "Nessun modello di messaggio. Creane uno per inviare messaggi fuori dalla finestra di 24 ore.",
        "nameHint": "Solo minuscole, numeri e underscore",
        "nameInvalid": "Il nome deve essere minuscolo con lettere, numeri e underscore",
        "bodyRequired": "Il corpo del modello è obbligatorio",
        "bodyLabel": "Corpo del messaggio",
        "bodyPlaceholderHint": "Usa {{1}}, {{2}}, … per valori dinamici. Meta richiede un esempio per ogni variabile.",
        "variableSamplesTitle": "Esempi variabili per revisione Meta",
        "variableSamplesHint": "Fornisci testi di esempio realistici. Meta rifiuta modelli senza esempi (INVALID_FORMAT).",
        "variableSampleLabel": "Esempio per {{index}}",
        "variableSamplePlaceholder": "Valore di esempio per i revisori Meta",
        "variableSamplesRequired": "Inserisci un esempio per ogni variabile nel testo del messaggio",
        "variableSampleMetaSlot": "Segnaposto Meta {{index}}",
        "variables": {
          "customerName": "Nome cliente",
          "studioName": "Nome studio",
          "managerName": "Nome del manager",
          "className": "Nome corso o sessione",
          "classDate": "Data del corso",
          "classTime": "Orario del corso",
          "followUpNote": "Messaggio di follow-up",
          "visitDatetime": "Data e ora della visita",
          "bookingDate": "Data prenotazione",
          "bookingTime": "Ora prenotazione",
          "newDate": "Nuova data",
          "newTime": "Nuova ora",
          "spotDate": "Data del posto",
          "spotTime": "Ora del posto",
          "handoffNote": "Messaggio di passaggio",
          "reengagementNote": "Messaggio di riattivazione",
          "rebookOffer": "Offerta di riprenotazione",
          "membershipType": "Tipo di abbonamento",
          "renewalDate": "Data di rinnovo",
          "propertyName": "Nome proprietà",
          "checkinDate": "Data di check-in",
          "accessDetails": "Dettagli di accesso"
        },
        "testSendTo": "A (numero E.164)",
        "e164Invalid": "Inserisci un numero E.164 valido (es. +393331234567)",
        "variableLabel": "Variabile {{index}}",
        "delete": "Elimina modello",
        "deleteConfirmTitle": "Eliminare il modello di messaggio?",
        "deleteConfirmBody": "Eliminare «{{name}}» (stato: {{status}})? Il modello verrà rimosso da Meta. Potrebbe essere necessario ricrearlo per inviare messaggi fuori dalla finestra di 24 ore. I modelli bootstrap OktoGo potrebbero dover essere ricreati.",
        "deleteConfirmAction": "Elimina modello",
        "deleteSuccess": "Modello eliminato",
        "deleteFailed": "Impossibile eliminare il modello",
        "deleteNotDeletable": "Questo modello non può essere eliminato mentre è in sospeso o approvato",
        "rejectionReason": "Motivo del rifiuto: {{reason}}",
        "presetClassReminder": "Promemoria lezione con dettagli prenotazione (invio demo T-1)",
        "presetSupportFollowup": "Follow-up manager dopo escalation IA (T-2)",
        "presetTrialWelcome": "Benvenuto prova — demo crea/invia (T-3)",
        "catalog": {
          "classReminder": "Promemoria lezione o sessione con data, ora e modifica prenotazione",
          "supportFollowup": "Follow-up manager dopo passaggio dal copilota IA o richiesta aperta",
          "trialWelcome": "Conferma prima prova o prima visita",
          "bookingConfirmed": "Conferma prenotazione dopo prenotazione studio o IA",
          "bookingCancelled": "Avviso di cancellazione con opzione di riprenotazione",
          "bookingRescheduled": "Modifica data o ora della prenotazione",
          "waitlistAvailable": "Posto in lista d'attesa — invita il cliente a prenotare",
          "aiHandoff": "Copilota IA in escalation — un manager risponderà a breve",
          "inactiveReengagement": "Ricontatto cliente fuori dalla finestra 24 ore",
          "classCancelledStudio": "Lezione o sessione annullata dallo studio",
          "membershipRenewal": "Promemoria rinnovo abbonamento o pacchetto",
          "stayCheckin": "Dettagli check-in per affitti brevi e assistenza all'arrivo"
        }
      }
    },
    "instagram": {
      "humanAgentEligible": "Idoneo a Human Agent",
      "humanAgentEligibleYes": "Sì",
      "humanAgentEligibleNo": "No"
    },
    "webhookPending": {
      "banner": "Connessione attiva, ma la consegna dei messaggi è in attesa di verifica",
      "reverify": "Verifica di nuovo il webhook"
    },
    "whatsappActivate": {
      "banner": "WhatsApp è collegato ma non ancora attivato per la messaggistica. Inserisci il PIN WhatsApp a 6 cifre per completare la configurazione.",
      "cta": "Completa attivazione",
      "title": "Completa attivazione WhatsApp",
      "description": "Inserisci il PIN a 6 cifre della verifica in due passaggi WhatsApp. Non modificare prima il PIN in WhatsApp Manager — completa l'attivazione qui così Meta registra il numero con Cloud API. OktoGo non memorizza questo PIN.",
      "pinLabel": "PIN WhatsApp",
      "pinPlaceholder": "PIN a 6 cifre",
      "submit": "Attiva",
      "cancel": "Annulla",
      "close": "Chiudi",
      "success": "WhatsApp è attivato per la messaggistica.",
      "errors": {
        "pinInvalid": "Il PIN non corrisponde alla verifica in due passaggi WhatsApp.",
        "reverificationRequired": "WhatsApp richiede una nuova verifica del telefono in Meta Business.",
        "rateLimited": "Troppi tentativi. Riprova entro 72 ore.",
        "generic": "Attivazione non riuscita. Riprova.",
        "network": "Errore di rete durante l'attivazione."
      }
    },
    "firstTrialReadiness": {
      "title": "Stato link primo trial",
      "precedenceNote": "Modifica questi link in Dati studio → Generale. Connessioni mostra solo lo stato.",
      "scenario1Ready": "Scenario 1 pronto: link registrazione/prova configurato",
      "scenario1Missing": "Scenario 1: link registrazione/prova mancante",
      "scenario2Ready": "Scenario 2 pronto: pagina Eversports dello studio configurata",
      "scenario2Missing": "Scenario 2: pagina Eversports dello studio mancante",
      "ctaStudioData": "Apri Studio Data",
      "ctaAiSettings": "Apri AI Settings"
    }
  },
  "archive": {
    "permissionToast": "Non hai l’autorizzazione per accedere all’archivio.",
    "restoreError": "Ripristino non riuscito",
    "studioLimitReached": "Massimo 5 studi attivi. Archivia uno studio prima di ripristinare questo.",
    "conversationRestored": "Conversazione ripristinata",
    "studioRestored": "Studio ripristinato",
    "deleteError": "Eliminazione non riuscita",
    "deleteBlockedFeedback": "Questa conversazione ha feedback IA e non può essere eliminata definitivamente. Rimane archiviata.",
    "conversationDeleted": "Conversazione eliminata definitivamente",
    "studioDeleted": "Studio eliminato definitivamente",
    "loadError": "Impossibile caricare l’archivio.",
    "empty": "Nessun elemento archiviato",
    "noFilterResults": "Nessun risultato per i filtri attuali.",
    "columnName": "Nome",
    "columnType": "Tipo",
    "columnStudio": "Studio",
    "columnArchived": "Archiviato",
    "columnActions": "Azioni",
    "channelTitle": "Canale",
    "channelWhatsapp": "WhatsApp",
    "channelInstagram": "Instagram",
    "channelUnknown": "—",
    "restore": "Ripristina",
    "deleteForever": "Elimina definitivamente",
    "purgeTitle": "Elimina definitivamente",
    "purgeBodyConversation": "Eliminare definitivamente questa conversazione archiviata ({{name}})? L’azione non può essere annullata.",
    "purgeBodyStudio": "Eliminare definitivamente questo studio archiviato ({{name}})? L’azione non può essere annullata.",
    "purgeDangerConversation": "Tutti i messaggi e i metadati di questa conversazione saranno rimossi dal database.",
    "purgeDangerStudio": "Lo studio e i dati correlati saranno rimossi definitivamente dal database.",
    "loadMore": "Carica altro",
    "purgeConversationTitle": "Eliminare la conversazione definitivamente?",
    "purgeConversationBody": "Rimuove definitivamente la chat archiviata. L’azione non può essere annullata.",
    "purgeStudioTitle": "Eliminare lo studio definitivamente?",
    "purgeStudioBody": "Digita il nome dello studio per confermare l’eliminazione definitiva.",
    "searchAria": "Cerca nell’archivio per nome",
    "filter": {
      "panelTitle": "Filtro",
      "panelDescription": "Filtra chat e studio archiviati per tipo, studio e data di archiviazione.",
      "filterArchiveAria": "Filtra archivio",
      "sectionType": "Tipo",
      "sectionStudio": "Studio",
      "sectionArchivedAgo": "Archiviato da",
      "typeAll": "Tutti",
      "typeChat": "Chat",
      "typeStudio": "Studio",
      "allStudios": "Tutti gli studio",
      "filterByStudioAria": "Filtra per studio",
      "tagTypeChat": "Tipo: chat",
      "tagTypeStudio": "Tipo: studio",
      "tagStudio": "Studio: {{name}}",
      "tagArchived": "Archiviato: {{label}}",
      "studioFallback": "Studio"
    },
    "time": {
      "all": "Tutte le date",
      "today": "Oggi",
      "yesterday": "Ieri",
      "this_week": "Questa settimana",
      "last_week": "Settimana scorsa",
      "this_month": "Questo mese",
      "last_month": "Mese scorso",
      "this_year": "Quest’anno"
    },
    "rowType": {
      "conversation": "Chat",
      "studio": "Studio"
    }
  },
  "studio": {
    "scopeAllStudiosRejected": "«Tutti gli studio» non è disponibile per il tuo account. È stato selezionato un singolo studio.",
    "scopeSwitchFailed": "Impossibile aggiornare il contesto studio. Riprova."
  },
  "vertical": {
    "fitness": {
      "dataSectionNavLabel": "Dati studio",
      "dataSectionPageTitle": "Dati studio",
      "dataSectionReadOnlyNoun": "Dati studio",
      "dataSectionAddUnitExpandedLabel": "Aggiungi studio",
      "dataSectionListColumnTitle": "Studio",
      "dataSectionMobileDescription": "Gestisci le informazioni dello studio, FAQ, policy e calendario corsi.",
      "aggregateScopeLabel": "Tutti gli studio",
      "selectScopeActionLabel": "Seleziona studio",
      "overlaySelectScopeMessage": "Passa a uno studio specifico per modificare le impostazioni.",
      "teamInviteUnitsMulti": "Studio (uno o più)",
      "teamInviteUnitsSingle": "Studio",
      "teamInviteNoUnitsAvailable": "Nessuno studio disponibile per inviti su questo account.",
      "teamInviteSelectAtLeastOne": "Seleziona almeno uno studio.",
      "chatsConversationUnitLabel": "Studio",
      "chatsIdentificationMatchingCopy": "Stiamo associando questo contatto a un membro dello studio. Potrebbe volerci un attimo.",
      "agentTraceSelectScopeMessage": "Seleziona uno studio per caricare le trace.",
      "agentTraceLoadErrorNeedsScope": "Seleziona uno studio e inserisci un UUID di esecuzione agente valido.",
      "agentTraceNoAuditEventsForUnit": "Nessun evento di audit per questo studio in questa finestra temporale.",
      "aiSettingsContactOwnerReadOnly": "Contatta il titolare dello studio per modificare le impostazioni IA.",
      "onboardingBookingConnectTitle": "Collega piattaforma di prenotazione",
      "onboardingBookingConnectSubtitle": "Collega la tua piattaforma per sincronizzare corsi, calendari e abbonamenti.",
      "onboardingBookingUsernamePlaceholder": "tu@studio.it",
      "dashboardStatConversationsToday": "Conversazioni oggi",
      "dashboardStatHandledByAiPct": "Gestite dall’IA %",
      "dashboardStatBookingsMade": "Prenotazioni effettuate",
      "dashboardStatAvgFirstResponse": "Prima risposta media",
      "chatsMockJoinedBookingLine": "Iscritto a Eversports",
      "chatsMockMembershipHeading": "Abbonamento",
      "chatsMockScheduleHeading": "Corsi",
      "chatsCustomerPanelPlatformsHeading": "Piattaforme",
      "chatsCustomerPanelAggregatorLabel": "Aggregatore",
      "chatsCustomerPanelNetworkLabel": "Rete",
      "chatsCustomerPanelPrimaryPlatformIdLabel": "ID cliente Eversports",
      "chatsCustomerPanelSecondaryPlatformIdLabel": "ID membro myClubs",
      "chatsCustomerPanelAggregatorIdLabel": "ID aggregatore",
      "chatsCustomerPanelCustomerRecordIdLabel": "ID cliente",
      "chatsCustomerPanelConversationRefLabel": "Conversazione",
      "chatsUnmatchedNotFoundTitle": "Cliente non trovato in Eversports",
      "chatsUnmatchedNotFoundBody": "Questo contatto non corrisponde a nessun membro noto. Potrebbe servire una ricerca manuale.",
      "chatsIdentificationInProgressTitle": "Identificazione cliente in corso",
      "chatsNoMembershipRecordTitle": "Nessuna scheda abbonamento",
      "chatsNoMembershipRecordBody": "Sembra una richiesta generica o un potenziale nuovo membro.",
      "visionAgentTraceButtonLabel": "Trace agente Vision",
      "pageScopeDescription": "Dashboard, chat e dati studio sotto seguono lo studio selezionato qui. Usa «Tutti gli studio» per una vista aggregata dove disponibile.",
      "connectionsTableUnitColumn": "Studio",
      "settingsAccountVerticalTitle": "Verticale prodotto",
      "settingsAccountVerticalHint": "Fitness mantiene terminologia studio e corsi. Affitti brevi passa a contesto struttura e canali annuncio."
    },
    "str": {
      "dataSectionNavLabel": "Dati struttura",
      "dataSectionPageTitle": "Dati struttura",
      "dataSectionReadOnlyNoun": "Dati struttura",
      "dataSectionAddUnitExpandedLabel": "Aggiungi struttura",
      "dataSectionListColumnTitle": "Strutture",
      "dataSectionMobileDescription": "Gestisci informazioni della struttura, FAQ, policy e dettagli per gli ospiti.",
      "aggregateScopeLabel": "Tutte le strutture",
      "selectScopeActionLabel": "Seleziona struttura",
      "overlaySelectScopeMessage": "Passa a una struttura specifica per modificare le impostazioni.",
      "teamInviteUnitsMulti": "Strutture (una o più)",
      "teamInviteUnitsSingle": "Struttura",
      "teamInviteNoUnitsAvailable": "Nessuna struttura disponibile per inviti su questo account.",
      "teamInviteSelectAtLeastOne": "Seleziona almeno una struttura.",
      "chatsConversationUnitLabel": "Struttura",
      "chatsIdentificationMatchingCopy": "Stiamo associando questo contatto a un ospite o a una prenotazione. Potrebbe volerci un attimo.",
      "agentTraceSelectScopeMessage": "Seleziona una struttura per caricare le trace.",
      "agentTraceLoadErrorNeedsScope": "Seleziona una struttura e inserisci un UUID di esecuzione agente valido.",
      "agentTraceNoAuditEventsForUnit": "Nessun evento di audit per questa struttura in questa finestra temporale.",
      "aiSettingsContactOwnerReadOnly": "Contatta il titolare della struttura per modificare le impostazioni IA.",
      "onboardingBookingConnectTitle": "Collega canale annunci",
      "onboardingBookingConnectSubtitle": "Collega la piattaforma di annunci o prenotazioni per sincronizzare disponibilità, prenotazioni e dettagli ospiti.",
      "onboardingBookingUsernamePlaceholder": "tu@esempio.it",
      "dashboardStatConversationsToday": "Conversazioni oggi",
      "dashboardStatHandledByAiPct": "Gestite dall’IA %",
      "dashboardStatBookingsMade": "Prenotazioni confermate",
      "dashboardStatAvgFirstResponse": "Prima risposta media",
      "chatsMockJoinedBookingLine": "Canale di prenotazione principale",
      "chatsMockMembershipHeading": "Programma ospiti",
      "chatsMockScheduleHeading": "Soggiorni in arrivo",
      "chatsCustomerPanelPlatformsHeading": "Canali",
      "chatsCustomerPanelAggregatorLabel": "Canale principale",
      "chatsCustomerPanelNetworkLabel": "Partner",
      "chatsCustomerPanelPrimaryPlatformIdLabel": "ID ospite",
      "chatsCustomerPanelSecondaryPlatformIdLabel": "Rif. prenotazione",
      "chatsCustomerPanelAggregatorIdLabel": "Rif. origine",
      "chatsCustomerPanelCustomerRecordIdLabel": "ID scheda ospite",
      "chatsCustomerPanelConversationRefLabel": "Conversazione",
      "chatsUnmatchedNotFoundTitle": "Ospite non trovato nel sistema di prenotazione",
      "chatsUnmatchedNotFoundBody": "Questo contatto non corrisponde a un ospite o prenotazione nota. Potrebbe servire una ricerca manuale.",
      "chatsIdentificationInProgressTitle": "Identificazione ospite in corso",
      "chatsNoMembershipRecordTitle": "Nessuna prenotazione in archivio",
      "chatsNoMembershipRecordBody": "Sembra una richiesta generica o una potenziale nuova prenotazione.",
      "visionAgentTraceButtonLabel": "Trace agente Vision",
      "pageScopeDescription": "Dashboard, chat e dati struttura sotto seguono la struttura selezionata qui. Usa «Tutte le strutture» per una vista aggregata dove disponibile.",
      "connectionsTableUnitColumn": "Struttura",
      "settingsAccountVerticalTitle": "Verticale prodotto",
      "settingsAccountVerticalHint": "Affitti brevi usa terminologia struttura e ospite con integrazioni annunci. Fitness usa studio e corsi."
    }
  },
  "notFound": {
    "code": "404",
    "title": "Ops! Pagina non trovata",
    "home": "Torna alla home"
  },
  "setupNotComplete": {
    "title": "Configurazione studio non completata",
    "body": "Il proprietario dello studio non ha ancora completato la configurazione. Avrai accesso al termine della configurazione."
  },
  "routeErrorBoundary": {
    "summary": "Impossibile caricare questa pagina. Prova a ricaricarla.",
    "reload": "Ricarica pagina"
  },
  "ai": {
    "readOnlyContactOwner": "Contatta il titolare dello studio per modificare le impostazioni IA.",
    "readOnlyContactOwnerStr": "Contatta il titolare della struttura per modificare le impostazioni IA.",
    "sectionReplies": "Risposte per argomento",
    "regimeLockedBanner": "Durante il pilota, l’invio automatico resta disattivato per tutti gli argomenti. Contatta OktoGo per sbloccare l’interruttore Auto/Manuale.",
    "toastRegimeLocked": "L’invio automatico è bloccato per questo studio pilota. Contatta OktoGo per sbloccarlo.",
    "sectionTone": "Tono della conversazione",
    "sectionLearn": "Impara dalle risposte del team",
    "sectionAttribution": "Etichette per risposte IA automatiche",
    "sectionEscalation": "Regole di escalation",
    "sectionEscalationHint": "Quando segnalare una conversazione per la tua revisione (escalation soft). L'IA scrive comunque una bozza — la approvi o la modifichi prima dell'invio. Il passaggio a un umano — se il cliente chiede una persona, o l'IA non può concludere in sicurezza — è una cintura di sicurezza separata e non è controllato da queste regole.",
    "sectionSessionNudge": "Solleciti finestra di messaggistica",
    "sectionSessionNudgeHint": "Messaggio breve opzionale al cliente prima della chiusura della finestra WhatsApp a testo libero. Viene eseguito solo se l’automazione server è attiva; una bozza IA in sospeso salta l’invio.",
    "escalationStillDraftsNote": "Sia che siano segnalate da queste regole o da un passaggio di sicurezza, le conversazioni con escalation attendono la tua approvazione — tranne i messaggi di conferma identità, sempre inviati così il cliente può iniziare. L'IA continua a proporre bozze di risposta, così non parti mai da zero.",
    "save": "Salva",
    "saving": "Salvataggio…",
    "saved": "Impostazioni IA salvate.",
    "saveError": "Impossibile salvare le impostazioni IA.",
    "loadError": "Impossibile caricare le impostazioni IA.",
    "bookingRequiredTitle": "Collega prima una piattaforma di prenotazione",
    "bookingRequiredBody": "L’attivazione della gestione automatica per gli argomenti di prenotazione funziona meglio con una piattaforma collegata in Impostazioni → Canali.",
    "confirmEnableBooking": "Attivare senza piattaforma di prenotazione collegata?",
    "enable": "Attiva",
    "useCase": {
      "booking": "Nuova prenotazione",
      "rebook": "Modifica prenotazione",
      "cancel": "Cancellazione",
      "info": "Informazioni generali",
      "schedule": "Richiesta orari",
      "trial": "Prova / prima visita",
      "account": "Account / abbonamento",
      "campaignLead": "Lead di campagna"
    },
    "firstTrial": {
      "helper": {
        "title": "Prova / prima visita — Copilot sceglie il percorso per te:",
        "scenario1": "Nessun account sulla piattaforma di prenotazione → link di registrazione / prova",
        "scenario2": "Account Eversports esistente, nuovo nel tuo studio → pagina Eversports dello studio; le prenotazioni restano bozza finché non è collegato al tuo studio",
        "scenario2Booking": "Dopo il collegamento valgono le regole di prenotazione normali (riga «Nuova prenotazione»)"
      },
      "readiness": {
        "title": "Stato link primo trial",
        "precedenceNote": "Modifica questi link in Dati studio → Generale. Connessioni mostra solo lo stato.",
        "scenario1Ready": "Scenario 1 pronto: link registrazione/prova configurato",
        "scenario1Missing": "Scenario 1: link registrazione/prova mancante",
        "scenario2Ready": "Scenario 2 pronto: pagina Eversports dello studio configurata",
        "scenario2Missing": "Scenario 2: pagina Eversports dello studio mancante",
        "ctaStudioData": "Apri Studio Data",
        "ctaConnections": "Apri Connections"
      }
    },
    "tone": {
      "friendly": {
        "label": "Amichevole",
        "desc": "Caldo, accessibile, con emoji. Inizia con il tu. Passa al Lei se il cliente o il team scrive chiaramente Lei."
      },
      "professional": {
        "label": "Formale",
        "desc": "Formale, senza emoji. Inizia con il Lei. Passa al tu se il cliente o il team scrive poi chiaramente tu."
      },
      "casual": {
        "label": "Informale",
        "desc": "Rilassato e breve. Inizia con il tu. Passa al Lei se il cliente o il team scrive chiaramente Lei."
      }
    },
    "repliesByTopicDesc": "Auto: dopo i controlli e la conferma del cliente quando richiesta (es. riprenotazione), l’IA può eseguire l’azione e inviare una conferma verificata. Manuale: dopo gli stessi controlli e la conferma del cliente, l’IA attende la tua approvazione prima di qualsiasi modifica sulla piattaforma e prima della conferma.",
    "repliesByTopicManualWait": "In Manuale, questi temi aspettano la tua approvazione.",
    "repliesByTopicStillSentChip": "Partono comunque da soli: conferma chi è, già nel corso, un «fatto» più tardi, un «sei verificato» più tardi, e un «annullo?» prima della tua conferma. Nient’altro.",
    "approveAllFirst": "Approva prima tutti i messaggi",
    "autoSendAllMessages": "Invia automaticamente tutti i messaggi",
    "bookingUseCaseHint": "Collega un’integrazione in Impostazioni → Canali per usare dati di calendario e prenotazioni in tempo reale.",
    "toneSectionDesc": "Stile iniziale per ogni conversazione. La chat può diventare più formale o più informale se il cliente o il team usa poi un tu o un Lei chiaro.",
    "learnSectionDesc": "L’IA riprende come scrive il team — lunghezza, tono, chiusura. Un Lei o tu chiaro del team basta per il suggerimento successivo. Vince l’ultimo tu/Lei chiaro del cliente o del team. Senza esempio chiaro vale lo stile iniziale sopra.",
    "attributionSectionDesc": "Le risposte IA inviate automaticamente compaiono sempre con questo nome assistente nelle chat. Le etichette non si possono disattivare. WhatsApp e Instagram usano comunque il tuo account business collegato — non questo nome.",
    "attributionDisplayNameLabel": "Nome visualizzato dell’assistente",
    "attributionDisplayNameHint": "Inserisci solo il nome — AI viene aggiunto automaticamente e non può essere rimosso. Esempio: Kai → Kai AI. I clienti WhatsApp e Instagram vedono comunque il tuo account business collegato.",
    "attributionDisplayNameErrorEmpty": "Inserisci un nome per l’assistente.",
    "attributionDisplayNameErrorToken": "Inserisci un nome per l’assistente.",
    "attributionDisplayNameAiSuffixTitle": "AI viene sempre aggiunto dopo il nome",
    "attributionDisplayNameAiSuffixSr": "AI è fisso dopo il nome e non è modificabile.",
    "attributionDisplayNameSave": "Salva nome assistente",
    "attributionDisplayNameReset": "Ripristina predefinito",
    "attributionBackendPendingHint": "Salvataggio non ancora disponibile — il server deve ancora esporre l’API del nome assistente. Puoi bozzeggiare e validare il nome qui.",
    "attributionStudio": "Nome studio",
    "attributionAi": "Assistente IA",
    "attributionLockedHint": "Solo titolare o manager possono modificare questa impostazione.",
    "toastAttributionSaved": "Nome visualizzato dell’assistente salvato.",
    "toastAttributionBackendNotReady": "Salvataggio non ancora possibile — il nome visualizzato dell’assistente non è disponibile sul server.",
    "escalateAfterPrefix": "Escalation dopo",
    "escalateAfterSuffix": "tentativi falliti prima di segnalare la conversazione per la tua revisione.",
    "dialogEnableAutoSendTitle": "Attiva invio automatico",
    "dialogEnableAutoSendBody": "Dopo i controlli richiesti e la conferma del cliente quando il flusso la richiede (es. riprenotazione = cancella + prenota), l’IA può eseguire questa azione e inviare una conferma verificata senza la tua approvazione. In modalità manuale attende la tua approvazione prima di qualsiasi modifica sulla piattaforma e prima della conferma. Continuare?",
    "dialogAutoSendAllTitle": "Invia automaticamente tutti i messaggi",
    "dialogAutoSendAllBody": "Per prenotazioni, modifiche e cancellazioni, l’IA agisce solo dopo i controlli richiesti e la conferma del cliente quando il flusso la richiede (riprenotazione = una conferma per cancella + prenota insieme). In modalità manuale attende la tua approvazione prima di qualsiasi modifica sulla piattaforma e prima della conferma.",
    "enableAll": "Attiva tutto",
    "toastSettingSaveError": "Impossibile salvare questa impostazione.",
    "toastAttributionError": "Aggiornamento etichette risposte automatiche non riuscito.",
    "toastEscalationError": "Aggiornamento regole di escalation non riuscito.",
    "sessionNudgeEnabled": "Attiva sollecito automatico di sessione",
    "sessionNudgeWhatsapp": "WhatsApp",
    "sessionNudgeInstagram": "Instagram (sperimentale)",
    "sessionNudgeOnlyEscalated": "Solo se in escalation",
    "sessionNudgeMaxOne": "Al massimo un sollecito per escalation",
    "sessionNudgeWhenRemaining": "Invia quando il tempo rimanente è al massimo",
    "sessionNudgeHours4": "4 ore",
    "sessionNudgeHours6": "6 ore",
    "sessionNudgeHours8": "8 ore",
    "sessionNudgePreview": "Anteprima messaggio predefinito",
    "sessionNudgePreviewMayDiffer": "Il messaggio effettivo può risultare più o meno formale a seconda della conversazione, in base a come il tuo team scrive a quel cliente.",
    "toastSessionNudgeError": "Impossibile salvare le impostazioni del sollecito di sessione.",
    "toastAutoHandleError": "Aggiornamento gestione automatica non riuscito.",
    "toastAutoHandleRateLimited": "Troppe modifiche in una volta. Riprova tra un momento.",
    "toastAutoHandleRateLimitedWithRetry": "Troppe modifiche in una volta. Riprova tra circa {{seconds}} secondi.",
    "toastToneError": "Aggiornamento tono non riuscito.",
    "toastGenericUpdateError": "Impossibile aggiornare le impostazioni.",
    "connectBookingFirst": "Collega prima una piattaforma di prenotazione in Impostazioni → Canali.",
    "connectListingFirst": "Collega prima un canale annunci in Impostazioni → Canali.",
    "campaignLeadNotReady": "Configura prima una campagna pronta in Dati studio → Campagne prima di attivarlo.",
    "campaignLead": {
      "hintNoCampaign": "Nessuna campagna configurata",
      "hintNotReady": "Campagna non ancora pronta",
      "hintEndDateMissing": "Alla campagna manca una data di fine",
      "hintEndingSoon": "La campagna termina il {{date}}",
      "hintExpired": "L'ultima campagna è scaduta",
      "hintSummaryActive": "{{count}} attive",
      "hintSummaryScheduled": "{{count}} programmate",
      "hintSummaryNotReady": "{{count}} non pronte",
      "hintSummaryExpired": "{{count}} scadute",
      "ctaOpenCampaigns": "Apri Campagne"
    },
    "groupBooking": {
      "sectionTitle": "Prenotazioni di gruppo",
      "sectionDesc": "Copilot rileva richieste di gruppo e aziendali dalla conversazione e le gestisce in modo sicuro invece di prenotare singoli posti.",
      "tabsAriaLabel": "Sezioni delle impostazioni delle prenotazioni di gruppo",
      "tabBasics": "Base",
      "tabPolicies": "Regole",
      "lockAria": "Solo titolare",
      "enableLabel": "Attiva le prenotazioni di gruppo per questo studio",
      "enableHint": "Quando è attivo, le conversazioni di tipo gruppo ricevono una bozza in attesa e una checklist per il manager invece di un invio automatico.",
      "fulfillmentLabel": "Come gestire le prenotazioni di gruppo?",
      "fulfillment": {
        "manual": "Manuale",
        "semiAutomated": "Semi-automatico",
        "fullyAutomated": "Completamente automatico",
        "manualDesc": "Copilot redige bozze e mostra una checklist del roster; tu prenoti manualmente nel manager della piattaforma.",
        "semiAutomatedDesc": "Copilot redige bozze; dopo la tua approvazione può eseguire passi sicuri del roster nel manager della piattaforma quando è pronto.",
        "fullyAutomatedDesc": "Solo pilota. Copilot può eseguire passi sicuri prima dell’approvazione; tu supervisioni e puoi intervenire in qualsiasi momento.",
        "requiresConnection": "Semi-automatico e Completamente automatico richiedono una piattaforma di prenotazione connessa. Connettine una in Impostazioni → Canali."
      },
      "maxPartyLabel": "Gruppo più grande che Copilot può automatizzare",
      "maxPartyHint": "Si applica solo a Semi-automatico e Completamente automatico. I gruppi più grandi restano manuali. Intervallo 2–50.",
      "escalationTargetLabel": "Avvisa per il passaggio",
      "escalationTargetHint": "Chi viene avvisato quando una prenotazione di gruppo richiede un umano. Consegna: Chat quando sei in Copilot; notifica mobile quando sei via (secondo Account → Notifiche).",
      "escalationTarget": {
        "owner": "Titolare dello studio",
        "allChatMembers": "Tutti i manager con accesso alle chat"
      },
      "saveButton": "Salva politica delle prenotazioni di gruppo",
      "toastSaved": "Politica delle prenotazioni di gruppo salvata.",
      "toastSaveError": "Impossibile salvare la politica delle prenotazioni di gruppo.",
      "toastEndpointUnavailable": "L’API della politica delle prenotazioni di gruppo non è ancora disponibile su questo server. Le impostazioni si applicheranno quando l’amministratore distribuirà l’aggiornamento backend.",
      "toastLoadUnavailable": "Impossibile caricare le impostazioni IA dal server.",
      "endpointUnavailableHint": "Il salvataggio è disabilitato finché l’endpoint della politica non è disponibile."
    },
    "escalation": {
      "no_match": "Nessuna intenzione riconosciuta",
      "sentiment": "Rilevato sentiment negativo",
      "repeat": "Il cliente ripete la richiesta 3 o più volte",
      "explicit": "Il cliente chiede un operatore umano"
    }
  },
  "channelConnect": {
    "header": {
      "connectInstagram": "Collega Instagram",
      "connectWhatsapp": "Collega WhatsApp",
      "selectStudioTooltip": "Seleziona un singolo studio per collegare i canali"
    },
    "wizard": {
      "yes": "Sì",
      "no": "No",
      "continue": "Continua",
      "back": "Indietro",
      "cancel": "Annulla",
      "retry": "Riprova",
      "learnMore": "Scopri di più",
      "instagram": {
        "title": "Collega Instagram",
        "introBody": "Collega il tuo account Instagram professionale così Oktogo può gestire i messaggi dei clienti in Chat.",
        "q1": "Hai già un account Instagram professionale (Business o Creator)?",
        "q1Yes": "Sì, ho un account professionale",
        "q1No": "No, non ancora",
        "q1HelpTitle": "Passa a un account professionale",
        "q1Help": "Apri Instagram → Impostazioni → Account → Passa a account professionale, poi scegli Business o Creator.",
        "q2": "Il tuo account Instagram è collegato a una Pagina Facebook?",
        "q2Yes": "Sì, è collegato a una Pagina Facebook",
        "q2No": "No, non ancora collegato",
        "q2HelpTitle": "Collega Instagram a una Pagina Facebook",
        "q2Help": "In Meta Business Suite o nelle impostazioni della Pagina Facebook, collega il tuo account Instagram alla Pagina dello studio.",
        "q3": "L'accesso ai messaggi è abilitato per questo account Instagram?",
        "q3Yes": "Sì, l'accesso ai messaggi è abilitato",
        "q3No": "No, non ancora abilitato",
        "q3HelpTitle": "Abilita l'accesso ai messaggi",
        "q3Help": "Nell'app Instagram: Impostazioni → Messaggi → Controlli messaggi → consenti l'accesso agli strumenti collegati.",
        "confirm": "Collega Instagram",
        "checkProfessional": "Account Instagram professionale (Business o Creator)",
        "checkFacebookPage": "Instagram collegato a una Pagina Facebook",
        "checkMessageAccess": "Accesso ai messaggi abilitato"
      },
      "whatsapp": {
        "title": "Collega WhatsApp",
        "introBody": "Collega WhatsApp Business così Oktogo può gestire i messaggi dei clienti in Chat.",
        "q1": "Hai un account WhatsApp Business (o un numero idoneo per l'API Business)?",
        "q1Yes": "Sì, ho WhatsApp Business",
        "q1No": "No, non ancora",
        "q1HelpTitle": "Configura WhatsApp Business",
        "q1Help": "Installa WhatsApp Business sul telefono dello studio o registra un numero con Meta per l'API Business.",
        "q2": "Puoi accedere con l'account Meta che amministra questa attività?",
        "q2Yes": "Sì, ho accesso amministratore Meta",
        "q2No": "No, non ho accesso amministratore",
        "q2HelpTitle": "Accesso amministratore Meta",
        "q2Help": "Serve l'accesso amministratore all'account Meta Business che possiede il profilo WhatsApp Business.",
        "confirm": "Collega WhatsApp",
        "checkBusiness": "Account WhatsApp Business pronto",
        "checkMetaAccess": "Accesso amministratore Meta confermato"
      }
    },
    "oauth": {
      "successInstagram": "Instagram collegato",
      "successInstagramHandle": "Collegato come {{handle}}",
      "successWhatsapp": "WhatsApp collegato",
      "webhookPending": "Instagram è connesso, ma la consegna dei messaggi è in attesa di verifica."
    },
    "errors": {
      "accessDenied": "Hai annullato le autorizzazioni. Riprova quando sei pronto.",
      "connectFailed": "Connessione non riuscita. Riprova."
    },
    "email": {
      "connect": "Connetti e-mail",
      "connectTooltip": "Connetti una casella condivisa per le e-mail clienti in Chats (tutti gli studi)",
      "wizard": {
        "title": "Connetti e-mail",
        "introBody": "Connetti la casella del tuo studio così OktoGo può gestire i thread e-mail clienti in Chats.",
        "providerGoogle": "Google (Gmail / Google Workspace)",
        "providerMicrosoft": "Microsoft (Outlook / Microsoft 365)",
        "prereqsTitle": "Prima di connettere",
        "prereqsBody": "Usa un account con cui puoi accedere tramite Google o Microsoft. Serve l’autorizzazione per collegare questa casella alla tua attività.",
        "confirm": "Connetti e-mail",
        "defaultStudioLabel": "Studio predefinito per nuovi thread e-mail",
        "defaultStudioHint": "Le nuove e-mail in arrivo sono instradate a questo studio finché il cliente non chiarisce diversamente.",
        "openChats": "Apri Chats"
      },
      "oauth": {
        "success": "E-mail connessa",
        "successAddress": "Connesso come {{address}}"
      }
    }
  },
  "whatsappSignup": {
    "title": "Collega WhatsApp Business",
    "description": "Autorizza OktoGo a gestire i messaggi per il tuo account WhatsApp Business.",
    "connectButton": "Connetti con Meta",
    "fbFlow": "Completa l'accesso nella finestra Meta…",
    "saving": "Salvataggio connessione…",
    "successRedirect": "WhatsApp collegato! Reindirizzamento…",
    "hint": "Accederai a Meta e selezionerai il tuo account WhatsApp Business.",
    "metaCompleteHint": "L'autorizzazione Meta è completata. Inserisci il PIN qui sotto per completare la connessione in OktoGo.",
    "pinDescription": "Inserisci il PIN a 6 cifre della verifica in due passaggi WhatsApp per registrare questo numero con l'API Cloud Meta.",
    "pinLabel": "PIN WhatsApp",
    "pinPlaceholder": "PIN a 6 cifre",
    "pinSubmit": "Attiva e collega",
    "retry": "Riprova",
    "errors": {
      "generic": "Qualcosa è andato storto.",
      "missingConfig": "Configurazione app Meta mancante. Controlla VITE_META_APP_ID e VITE_META_ES_CONFIG_ID.",
      "phoneAlreadyConnected": "Questo numero di telefono è già collegato a un altro studio del tuo account.",
      "metaExchangeFailed": "Meta non ha potuto scambiare il codice. Verifica l'URI di redirect del server.",
      "wabaDiscoveryFailed": "Account WhatsApp Business non trovato. Assicurati di avere un WABA con numero.",
      "studioContextRequired": "Seleziona uno studio specifico prima di collegare WhatsApp, poi riprova da Impostazioni o Chat.",
      "connectFailed": "Impossibile salvare la connessione WhatsApp. Riprova.",
      "sessionExpired": "La sessione è scaduta. Accedi di nuovo e riconnetti WhatsApp dalle impostazioni.",
      "network": "Errore di rete durante il salvataggio. Riprova.",
      "cancelled": "Accesso Meta annullato. Riprova.",
      "sdkLoadFailed": "Impossibile caricare l'SDK Meta. Aggiorna la pagina.",
      "activationRequired": "Inserisci il PIN WhatsApp a 6 cifre per attivare la messaggistica.",
      "pinInvalid": "Il PIN non corrisponde alla verifica in due passaggi WhatsApp.",
      "reverificationRequired": "WhatsApp richiede una nuova verifica del telefono in Meta Business.",
      "registerRateLimited": "Troppi tentativi di registrazione. Riprova entro 72 ore.",
      "registerFailed": "Registrazione del numero WhatsApp non riuscita. Riprova."
    }
  },
  "whatsappTemplates": {
    "title": "Modelli di messaggio",
    "subtitle": "Modelli approvati dal tuo account WhatsApp Business collegato (fuori dalla finestra di 24 ore).",
    "loading": "Caricamento modelli…",
    "empty": "Nessun modello di messaggio per questo account.",
    "errorLoad": "Impossibile caricare i modelli di messaggio.",
    "retry": "Riprova",
    "colName": "Nome",
    "colLanguage": "Lingua",
    "colCategory": "Categoria",
    "colStatus": "Stato"
  },
  "whatsappSetup": {
    "title": "Account WhatsApp collegato",
    "subtitle": "Dettagli live del tuo account WhatsApp Business (WABA), numero, verifica e abbonamento webhook.",
    "loading": "Caricamento dettagli account…",
    "errorLoad": "Impossibile caricare i dettagli dell'account WhatsApp.",
    "retry": "Riprova",
    "wabaId": "ID WABA",
    "phoneNumber": "Numero di telefono",
    "displayName": "Nome visualizzato",
    "phoneVerification": "Verifica telefono",
    "nameVerification": "Verifica nome visualizzato",
    "webhookSubscription": "Abbonamento webhook",
    "webhookSubscribed": "Abbonato",
    "webhookNotSubscribed": "Non abbonato",
    "webhookAppId": "ID app Meta",
    "webhookFields": "Campi abbonati"
  },
  "onboarding": {
    "shell": {
      "stepOf": "Passo {{current}} di {{total}}",
      "exitAria": "Esci dalla configurazione",
      "exitTitle": "Salvare i progressi e continuare più tardi?",
      "exitDescription": "I progressi verranno salvati. Potrai riprendere al prossimo accesso.",
      "cancel": "Annulla",
      "saveAndExit": "Salva ed esci"
    },
    "instagram": {
      "title": "Collega Instagram",
      "description": "Collega il tuo account Instagram Business così OktoGo può gestire i messaggi dei clienti.",
      "errorConnect": "Collegamento Instagram non riuscito. Riprova.",
      "connected": "Collegato",
      "connectButton": "Collega Instagram",
      "retry": "Riprova",
      "continue": "Continua",
      "skipLater": "Lo farò più tardi",
      "testErrorEnable": "(Test: attiva modalità errore)",
      "testErrorDisable": "(Test: disattiva modalità errore)"
    },
    "whatsapp": {
      "title": "Collega WhatsApp Business",
      "description": "Collega il tuo account WhatsApp Business così OktoGo può gestire i messaggi dei clienti.",
      "errorConnect": "Collegamento WhatsApp non riuscito. Riprova.",
      "connected": "Collegato",
      "connectButton": "Collega WhatsApp",
      "retry": "Riprova",
      "continue": "Continua",
      "skipLater": "Lo farò più tardi",
      "back": "Indietro"
    },
    "booking": {
      "title": "Collega la piattaforma di prenotazione",
      "description": "Collega la piattaforma per sincronizzare corsi, calendario e abbonamenti.",
      "errorCredentials": "Credenziali non valide o piattaforma non disponibile. Riprova.",
      "connected": "Collegato",
      "continue": "Continua",
      "platformLabel": "Piattaforma di prenotazione",
      "usernameLabel": "Nome utente / Email",
      "passwordLabel": "Password",
      "skipLater": "Lo farò più tardi",
      "disclosure": "Memorizziamo in modo sicuro le tue credenziali per sincronizzare prenotazioni e calendario. La password è crittografata ed è accessibile solo ai server sicuri di OktoGo.",
      "testConnection": "Prova connessione",
      "back": "Indietro",
      "testErrorEnable": "(Test: attiva modalità errore)",
      "testErrorDisable": "(Test: disattiva modalità errore)",
      "manualCodeLabel": "Codice di accesso aggiuntivo",
      "manualCodeHint": "Eversports ha inviato un codice monouso (SMS, email o app di autenticazione). Inseriscilo e ripeti il test.",
      "manualCodeRequiredTitle": "Verifica manuale richiesta"
    },
    "twoFa": {
      "title": "Configura le credenziali 2FA",
      "description": "Eversports richiede la 2FA. Fornisci le credenziali così OktoGo può autenticarsi per conto tuo.",
      "errorVerify": "Verifica 2FA non riuscita – controlla le credenziali e riprova.",
      "verified": "2FA verificata",
      "verifiedHint": "Autenticazione Eversports pronta",
      "continue": "Continua",
      "methodLabel": "Metodo 2FA",
      "methodAuthenticator": "App di autenticazione",
      "methodSms": "SMS",
      "methodBackup": "Codice di backup",
      "secretLabel": "Segreto 2FA / codice di backup",
      "disclosure": "Le credenziali 2FA sono crittografate e memorizzate solo per consentire a OktoGo di autenticarsi con Eversports per conto tuo. Non vengono mai condivise.",
      "skipLater": "Lo farò più tardi",
      "back": "Indietro",
      "testButton": "Prova 2FA",
      "syncLimitedHint": "La sincronizzazione può essere limitata finché non fornisci la 2FA",
      "testErrorEnable": "(Test: attiva modalità errore)",
      "testErrorDisable": "(Test: disattiva modalità errore)"
    },
    "email": {
      "title": "Collega e-mail",
      "description": "Collega la casella del tuo studio così OktoGo può gestire i thread e-mail dei clienti in Chat.",
      "connectButton": "Collega e-mail",
      "skipLater": "Lo farò più tardi",
      "back": "Indietro",
      "continue": "Continua",
      "connected": "E-mail collegata",
      "connectedHint": "La tua casella è pronta per le e-mail dei clienti in Chat.",
      "optionalHint": "Facoltativo — puoi collegare l'e-mail più tardi da Impostazioni."
    },
    "messaging": {
      "title": "Collega i canali di messaggistica",
      "description": "Collega Instagram e WhatsApp così OktoGo può gestire i messaggi dei clienti in Chat.",
      "continue": "Continua",
      "skipLater": "Lo farò più tardi",
      "back": "Indietro",
      "optionalHint": "Facoltativo — puoi collegarli più tardi da Impostazioni → Canali."
    },
    "oauthCallbackLoading": "Connessione dell’account…",
    "errors": {
      "connectFailed": "Connessione non riuscita. Riprova."
    },
    "sync": {
      "titleRunning": "Sincronizzazione dati dello studio…",
      "titleDone": "Sincronizzazione completata!",
      "titleSkipped": "Per ora sei a posto",
      "hintRunning": "Ci vorrà solo un momento.",
      "hintDone": "I dati del tuo studio sono stati importati correttamente.",
      "hintSkipped": "Nessuna piattaforma di prenotazione collegata ancora. Puoi collegarla più tardi da Impostazioni → Connessioni.",
      "stageClasses": "Recupero corsi",
      "stageSchedule": "Sincronizzazione calendario",
      "stageMemberships": "Importazione abbonamenti",
      "stagePolicies": "Caricamento policy",
      "continueDashboard": "Vai alla dashboard",
      "completing": "Completamento…",
      "summaryDemo": "{{classes}} corsi, {{sessions}} sessioni future, {{tiers}} livelli di abbonamento importati.",
      "summaryReal": "{{classes}} corsi e {{policies}} policy importati correttamente.",
      "summaryGeneric": "Dati dello studio importati correttamente.",
      "summaryNoData": "Configurazione completata. Puoi collegare una piattaforma di prenotazione più tardi da Impostazioni → Connessioni.",
      "confirmTitle": "Conferma i link pubblici Eversports",
      "confirmLinks": "Controlla gli URL Overview, Classes e Prices in Studio Data → Generale.",
      "confirmClassPrices": "Descrizioni dei corsi e Pricing options si sincronizzano da Eversports quando disponibili — controllali in Studio Data → Corsi.",
      "confirmHonesty": "I prezzi live di Eversports hanno priorità. Finché i prezzi per corso non sono disponibili, Copilot può inviare il link alla pagina Prices — non inventiamo mai importi in euro.",
      "ctaReviewLinks": "Controlla i link di sezione in Studio Data",
      "ctaReviewClasses": "Controlla corsi e prezzi in Studio Data",
      "titleError": "Sincronizzazione non riuscita",
      "hintError": "Non siamo riusciti a importare i dati del tuo studio in questo momento.",
      "errorBody": "Si è verificato un problema durante l'importazione dei dati. Puoi riprovare ora oppure completare la configurazione e riprovare più tardi dalle Impostazioni.",
      "retry": "Riprova sincronizzazione",
      "back": "Indietro"
    }
  },
  "management": {
    "title": "Gestione pilota",
    "subtitle": "Invita e controlla l'onboarding dei clienti pilota.",
    "signOut": "Disconnetti",
    "login": {
      "title": "Accesso management",
      "subtitle": "Accedi con un account admin piattaforma.",
      "emailLabel": "Email",
      "emailPlaceholder": "admin@oktogo.ai",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Inserisci la password",
      "signIn": "Accedi",
      "signingIn": "Accesso..."
    },
    "accept": {
      "title": "Accetta invito pilota",
      "subtitle": "Crea una password sicura per iniziare l'onboarding.",
      "email": "Email",
      "studio": "Studio",
      "expiresAt": "Scade il",
      "password": "Password",
      "passwordPlaceholder": "Crea una password",
      "terms": "Accetto i termini di onboarding pilota",
      "submit": "Accetta invito",
      "accepting": "Accettazione invito..."
    },
    "createInvite": {
      "title": "Crea invito pilota",
      "email": "Email proprietario",
      "fullName": "Nome completo (opzionale)",
      "studioName": "Nome studio",
      "planId": "ID piano",
      "submit": "Crea e invia invito",
      "creating": "Creazione invito..."
    },
    "invites": {
      "title": "Inviti pilota",
      "loading": "Caricamento inviti...",
      "empty": "Nessun invito per il filtro selezionato.",
      "filterAria": "Filtra inviti per stato",
      "filterAll": "Tutti gli stati",
      "columns": {
        "email": "Email",
        "studio": "Studio",
        "status": "Stato",
        "expiresAt": "Scade il",
        "actions": "Azioni"
      },
      "actions": {
        "resend": "Invia di nuovo",
        "revoke": "Revoca"
      }
    },
    "status": {
      "pending": "In attesa",
      "sent": "Inviato",
      "accepted": "Accettato",
      "expired": "Scaduto",
      "revoked": "Revocato"
    },
    "vertical": {
      "fitness": "Fitness",
      "shortTermRental": "Affitto breve"
    },
    "messages": {
      "inviteCreated": "Invito pilota creato ({{id}}).",
      "inviteActionSuccess": "Invito aggiornato.",
      "inviteAccepted": "Invito accettato. Il tuo account ora è attivo."
    },
    "errors": {
      "login": "Accesso non riuscito.",
      "platformAdminRequired": "È richiesto accesso admin piattaforma.",
      "loadInvites": "Impossibile caricare gli inviti.",
      "createInvite": "Impossibile creare l'invito.",
      "inviteAction": "Impossibile aggiornare l'invito.",
      "invalidInviteToken": "Token invito mancante.",
      "loadInviteToken": "Impossibile validare questo token invito.",
      "acceptInvite": "Impossibile accettare l'invito."
    }
  },
  "compliance": {
    "aiDisclosure": {
      "auto": {
        "plain": "Salve! Qui risponde l'assistente IA di questo studio. Posso aiutare con orari, prenotazioni e domande rapide - un membro del team può intervenire in qualsiasi momento.",
        "named": "Salve {{channelFirstName}}. Qui risponde l'assistente IA di questo studio. Posso aiutare con orari, prenotazioni e domande rapide - un membro del team può intervenire in qualsiasi momento."
      },
      "manual": {
        "plain": "Salve! Qui risponde l'assistente IA di questo studio. Ho preparato questa risposta e un membro del team l'ha controllata prima dell'invio - una persona del team è sempre disponibile.",
        "named": "Salve {{channelFirstName}}. Qui risponde l'assistente IA di questo studio. Ho preparato questa risposta e un membro del team l'ha controllata prima dell'invio - una persona del team è sempre disponibile."
      }
    }
  }
}
